var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageFirework(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 122,
    viewBox: "0 0 191 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.788 79.7201C129.688 79.8635 129.657 80.0339 129.702 80.2013C130.365 80.2011 131.031 80.296 131.669 80.4817C131.659 80.3232 131.717 80.1705 131.833 80.0481C131.178 79.8267 130.481 79.7149 129.788 79.7201Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.77 99.2015C155.874 99.0379 156.031 98.9035 156.225 98.8123C156.419 98.7211 156.642 98.6764 156.873 98.683C156.496 98.2313 156.004 97.8498 155.436 97.5678C155.234 97.5784 155.042 97.633 154.879 97.7262C154.717 97.8194 154.59 97.948 154.512 98.099C155.045 98.3637 155.482 98.7471 155.77 99.2015Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.018 62.2764C168.626 62.1427 168.284 61.9179 168.034 61.6307C167.946 61.7333 167.809 61.7997 167.654 61.8153C167.906 62.1473 168.258 62.422 168.673 62.6094C168.822 62.5259 168.941 62.4114 169.018 62.2764Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.657 67.2514C151.917 67.0817 151.215 66.7951 150.591 66.4081C150.348 66.6599 150.218 66.9774 150.223 67.3108C150.851 67.7198 151.545 68.0506 152.28 68.2916C152.204 67.7549 152.266 67.4819 152.657 67.2514Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.142 33.7059C146.706 34.0033 147.265 33.987 148.145 33.7982C147.815 32.7957 147.761 31.7586 147.989 30.7681C147.299 30.8796 146.566 30.7761 145.926 30.4765C145.734 31.5387 145.807 32.6379 146.142 33.7059Z",
    fill: "url(#paint4_linear_0_1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.093 61.6604C176.176 61.4715 176.205 61.267 176.18 61.0615C176.154 60.8561 176.074 60.6546 175.945 60.4714C175.111 60.4312 174.28 60.3102 173.468 60.1109C173.515 60.3308 173.492 60.553 173.402 60.7558C174.341 60.9463 175.248 61.2514 176.093 61.6604Z",
    fill: "url(#paint5_linear_0_1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9297 20.9338C78.6781 20.9519 78.4382 21.0168 78.2271 21.1236C78.016 21.2305 77.8389 21.3769 77.7085 21.5522C78.1129 22.1996 78.4285 22.8794 78.649 23.5776C78.8656 23.4466 79.1225 23.3665 79.3952 23.3449C79.0982 22.557 78.9412 21.7442 78.9297 20.9338Z",
    fill: "url(#paint6_linear_0_1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1872 54.0705C98.6493 55.0855 98.3356 56.1839 98.2604 57.3158C99.0984 57.4008 99.9328 57.2961 100.675 57.0128C100.535 56.2948 100.766 55.7799 101.199 55.0138C100.811 54.9862 100.43 54.8872 100.082 54.724C99.7337 54.5609 99.4282 54.3377 99.1872 54.0705Z",
    fill: "url(#paint7_linear_0_1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5671 56.79C69.4177 57.7746 69.5969 58.7933 70.0853 59.7357C70.8072 59.8824 71.5504 59.8212 72.1917 59.5622C71.699 58.6353 71.5327 57.6264 71.7134 56.6603C70.8652 56.9941 70.3365 57.0817 69.5671 56.79Z",
    fill: "url(#paint8_linear_0_1)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M120.311 62.869C120.478 62.7398 120.679 62.6452 120.902 62.5923C120.542 62.3271 120.224 62.0248 119.958 61.6939C119.726 61.6967 119.51 61.7703 119.35 61.9008C119.625 62.2518 119.947 62.5769 120.311 62.869Z",
    fill: "url(#paint9_linear_0_1)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M161.163 41.0184C160.527 41.517 159.616 41.785 157.388 41.721C157.588 42.5404 158.102 43.303 158.852 43.8961C160.271 43.8426 161.626 43.4922 162.788 42.878C162.027 42.4049 161.456 41.7525 161.163 41.0184Z",
    fill: "url(#paint10_linear_0_1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.73 102.529C144.049 102.627 144.333 102.799 144.544 103.024C144.576 102.982 144.618 102.946 144.668 102.919C144.718 102.891 144.775 102.872 144.836 102.863C144.615 102.6 144.313 102.387 143.964 102.251C143.858 102.325 143.777 102.42 143.73 102.529Z",
    fill: "url(#paint11_linear_0_1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4243 70.3277C91.3838 70.5177 91.398 70.716 91.4659 70.907C91.5337 71.0979 91.6533 71.2764 91.8152 71.4284C92.5334 71.1177 93.3403 70.9525 94.1736 70.9456C93.934 70.5835 93.8522 70.1719 93.9427 69.7836C93.0551 69.819 92.1981 70.0042 91.4243 70.3277Z",
    fill: "url(#paint12_linear_0_1)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.681 79.0243C116.109 79.0828 116.54 79.0627 116.944 78.9654C117.348 78.8681 117.716 78.6959 118.021 78.4611C117.67 77.2823 117.482 76.0825 117.463 74.8863C117.038 75.0196 116.571 75.0562 116.108 74.9927C116.211 76.361 116.067 77.7202 115.681 79.0243Z",
    fill: "url(#paint13_linear_0_1)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.433 20.0115C141.861 20.0713 142.292 20.0518 142.697 19.9545C143.101 19.8571 143.469 19.6842 143.773 19.4483C143.419 18.2682 143.231 17.0665 143.215 15.8687C142.79 16.0026 142.323 16.0393 141.86 15.9751C141.964 17.3451 141.82 18.7059 141.433 20.0115Z",
    fill: "url(#paint14_linear_0_1)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.841 73.6552C154.551 73.3183 154.179 73.0322 153.752 72.8167C153.326 72.6013 152.854 72.4614 152.369 72.4068C151.456 73.4728 150.385 74.4363 149.178 75.277C149.664 75.4845 150.085 75.7894 150.399 76.1617C151.703 75.1374 153.201 74.2924 154.841 73.6552Z",
    fill: "url(#paint15_linear_0_1)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.45 98.594C100.67 98.7553 100.85 98.9517 100.977 99.17C101.284 98.797 101.653 98.4644 102.075 98.1815C102.021 97.95 101.867 97.7376 101.641 97.5866C101.193 97.8779 100.793 98.2162 100.45 98.594Z",
    fill: "url(#paint16_linear_0_1)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.566 47.4331C109.745 47.4668 108.978 47.7251 108.383 48.1684C108.377 48.6548 108.282 49.1325 108.101 49.5848C108.621 49.4091 109.002 49.5241 109.678 49.9402C109.803 49.0599 110.103 48.2129 110.566 47.4331Z",
    fill: "url(#paint17_linear_0_1)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.461 84.3553C139.656 84.6845 139.965 84.8426 140.465 85.0465C141.031 84.0577 141.813 83.1738 142.772 82.4367C142.407 82.2615 142.114 81.9931 141.94 81.6744C140.881 82.3962 140.035 83.3104 139.461 84.3553Z",
    fill: "url(#paint18_linear_0_1)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.711 79.1943C160.786 79.0195 160.907 78.8629 161.066 78.7354C161.225 78.6078 161.418 78.5123 161.632 78.4556C160.824 77.6368 159.885 76.9106 158.844 76.2994C158.361 76.4986 157.961 76.8055 157.686 77.1881C158.871 77.6389 159.913 78.3305 160.711 79.1943Z",
    fill: "url(#paint19_linear_0_1)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.138 68.1064C105.161 68.2588 105.231 68.4063 105.342 68.5339C105.453 68.6615 105.6 68.7646 105.769 68.8328C106.105 68.762 106.394 68.5946 106.586 68.3588C106.396 68.0127 106.322 67.6356 106.373 67.2702C106.04 67.6204 105.62 67.905 105.138 68.1064Z",
    fill: "url(#paint20_linear_0_1)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.658 79.5903C100.595 79.3843 100.47 79.192 100.294 79.0329C100.118 78.8737 99.8978 78.7533 99.6561 78.6836C99.219 78.8345 98.8645 79.1062 98.6485 79.4562C98.9783 79.9042 99.1568 80.4122 99.1639 80.9221C99.5422 80.3921 100.051 79.9391 100.658 79.5903Z",
    fill: "url(#paint21_linear_0_1)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.09 103.944C109.837 103.973 109.607 104.069 109.433 104.218C109.653 104.364 109.816 104.561 109.898 104.781C110.141 104.762 110.372 104.702 110.579 104.605C110.369 104.41 110.203 104.185 110.09 103.944Z",
    fill: "url(#paint22_linear_0_1)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M121.335 68.5521C121.513 68.2199 121.615 67.8589 121.635 67.4869C121.361 67.4597 121.088 67.4937 120.845 67.5855C120.876 67.821 120.816 68.0533 120.672 68.2473C120.799 68.2557 120.924 68.2873 121.039 68.34C121.154 68.3927 121.255 68.4651 121.335 68.5521Z",
    fill: "url(#paint23_linear_0_1)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9944 21.094C99.3858 20.3465 99.6119 19.5383 99.6624 18.7061C99.046 18.6495 98.4339 18.7289 97.8876 18.9363C97.9593 19.4589 97.8271 19.9751 97.5108 20.4073C97.7959 20.427 98.0766 20.4988 98.333 20.6175C98.5894 20.7361 98.8152 20.8988 98.9944 21.094Z",
    fill: "url(#paint24_linear_0_1)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M129.037 92.6532C128.742 92.8308 128.371 92.9075 127.995 92.8686C128.242 93.3298 128.578 93.7584 128.99 94.1364C129.306 94.0218 129.585 93.8524 129.81 93.6387C129.471 93.3574 129.207 93.0206 129.037 92.6532Z",
    fill: "url(#paint25_linear_0_1)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M126.813 24.436C126.564 25.1213 126.545 25.8633 126.76 26.5834C127.268 26.751 127.816 26.7763 128.319 26.6551C128.094 25.9452 128.121 25.21 128.395 24.5413C128.15 24.6337 127.878 24.6724 127.602 24.654C127.326 24.6356 127.055 24.5607 126.813 24.436Z",
    fill: "url(#paint26_linear_0_1)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M135.505 76.2663C135.545 76.6201 135.457 76.9684 135.253 77.2656C135.332 77.2794 135.407 77.3069 135.474 77.3463C135.542 77.3858 135.599 77.4362 135.642 77.4942C135.897 77.1793 136.036 76.8047 136.044 76.4128C135.878 76.3274 135.693 76.277 135.505 76.2663Z",
    fill: "url(#paint27_linear_0_1)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M146.457 47.0405C146.617 46.9976 146.788 46.9845 146.96 47.0022C147.131 47.0198 147.299 47.0678 147.451 47.1428C147.584 46.3826 147.583 45.6024 147.447 44.827C147.055 44.6886 146.633 44.6414 146.227 44.6908C146.549 45.4576 146.628 46.2683 146.457 47.0405Z",
    fill: "url(#paint28_linear_0_1)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.656 31.8608C104.298 31.9118 103.979 32.0609 103.748 32.2851C103.776 32.5032 103.763 32.7214 103.708 32.9311C103.93 32.8341 104.103 32.8654 104.43 33.0249C104.427 32.6246 104.503 32.2313 104.656 31.8608Z",
    fill: "url(#paint29_linear_0_1)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M108.318 10.2609C107.673 10.4996 106.885 10.505 105.189 9.99764C105.091 10.6421 105.253 11.3094 105.649 11.9011C106.754 12.1532 107.901 12.1751 108.98 11.9648C108.546 11.4575 108.313 10.8599 108.318 10.2609Z",
    fill: "url(#paint30_linear_0_1)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9684 57.1025C84.9514 56.8253 85.0324 56.5557 85.2012 56.3276C85.1398 56.3134 85.0817 56.2892 85.0303 56.2563C84.9789 56.2234 84.9352 56.1825 84.902 56.1361C84.6907 56.3775 84.568 56.6681 84.5475 56.9756C84.6742 57.0482 84.8196 57.092 84.9684 57.1025Z",
    fill: "url(#paint31_linear_0_1)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7972 49.6888C90.0671 49.7215 90.3356 49.6743 90.5558 49.5553C90.1638 48.9013 89.9115 48.2015 89.8109 47.4894C89.5799 47.5692 89.3183 47.5802 89.0675 47.5207C89.1263 48.2682 89.3751 49.0075 89.7972 49.6888Z",
    fill: "url(#paint32_linear_0_1)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6772 66.1693C76.9039 66.4029 77.2126 66.5752 77.5569 66.6605C77.7739 66.5639 78.0106 66.4968 78.2583 66.4615C78.0508 66.3393 78.0041 66.2017 78.0103 65.9174C77.5906 66.0606 77.1404 66.1457 76.6772 66.1693Z",
    fill: "url(#paint33_linear_0_1)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M116.72 37.312C116.394 37.1805 116.041 37.1089 115.688 37.1024C115.335 37.0958 114.99 37.1544 114.677 37.274C114.618 38.2504 114.421 39.2096 114.089 40.1316C114.469 40.115 114.855 40.1809 115.208 40.3228C115.522 39.2503 116.031 38.2351 116.72 37.312Z",
    fill: "url(#paint34_linear_0_1)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4764 60.913C88.9121 61.3144 88.5013 61.8445 88.2885 62.4459C88.5915 62.7617 89.0076 62.9896 89.4686 63.0922C89.6708 62.4965 90.0818 61.975 90.6514 61.5914C90.4092 61.567 90.1741 61.4919 89.9685 61.3732C89.7629 61.2545 89.5935 61.0961 89.4764 60.913Z",
    fill: "url(#paint35_linear_0_1)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M131.33 70.3482C132.105 70.0242 132.711 69.4906 133.055 68.8298C132.153 68.5526 131.365 68.0467 130.807 67.388C130.057 67.6694 129.396 68.0798 128.866 68.5937C129.807 69.048 130.644 69.644 131.33 70.3482Z",
    fill: "url(#paint36_linear_0_1)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M106.96 79.7609C107.433 79.5578 107.854 79.2846 108.202 78.9538C107.938 78.7644 107.624 78.6315 107.29 78.5678C107.12 78.8056 106.855 78.9843 106.537 79.0756C106.662 79.1602 106.765 79.2656 106.838 79.3841C106.911 79.5026 106.953 79.6313 106.96 79.7609Z",
    fill: "url(#paint37_linear_0_1)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0606 89.2924C79.3114 89.374 79.5818 89.3864 79.8302 89.3277C79.7166 89.1102 79.6891 88.8724 79.752 88.6508C79.5183 88.5638 79.2691 88.516 79.0195 88.5104C79.0938 88.7699 79.1078 89.0355 79.0606 89.2924Z",
    fill: "url(#paint38_linear_0_1)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M121.889 49.533C122.134 50.0513 122.143 50.6133 121.915 51.1101C122.939 51.0476 123.931 50.8444 124.852 50.5084C124.757 50.0018 124.532 49.5106 124.193 49.0681C123.488 49.3657 122.701 49.5245 121.889 49.533Z",
    fill: "url(#paint39_linear_0_1)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M97.525 43.2444C97.4458 43.5411 97.4639 43.8554 97.5774 44.1556C97.6909 44.4557 97.8959 44.7311 98.1715 44.954C98.8912 45.0112 99.5964 44.8661 100.173 44.5422C100.082 43.7879 100.247 43.0421 100.649 42.3899C99.702 42.8509 98.6395 43.1415 97.525 43.2444Z",
    fill: "url(#paint40_linear_0_1)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M151.131 103.56C150.542 103.635 150.235 103.917 149.742 104.385C151.197 105.478 152.419 106.769 153.347 108.195C153.727 107.862 154.238 107.651 154.801 107.595C153.92 106.067 152.668 104.692 151.131 103.56Z",
    fill: "url(#paint41_linear_0_1)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1356 47.1316C75.0437 45.9789 75.1067 45.3911 75.5797 44.5364C75.379 44.5127 75.1835 44.4546 75.0056 44.3657C74.8277 44.2767 74.6713 44.159 74.5464 44.0199C73.9665 44.8656 73.6882 45.8455 73.7423 46.8516C74.1781 47.0434 74.6583 47.1399 75.1356 47.1316Z",
    fill: "url(#paint42_linear_0_1)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M88.731 84.7413C88.52 85.0746 88.2221 85.3623 87.8569 85.5857C88.7285 85.9004 89.5519 86.3085 90.3045 86.7986C90.7357 86.6675 91.0786 86.4029 91.2637 86.0584C90.4798 85.5411 89.6295 85.0989 88.731 84.7413Z",
    fill: "url(#paint43_linear_0_1)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M119.354 12.5661C119.491 12.6758 119.6 12.8072 119.674 12.9513C119.747 13.0953 119.783 13.2487 119.779 13.4008C120.729 13.1961 121.628 12.8758 122.447 12.4498C122.391 12.0803 122.214 11.7235 121.935 11.4188C121.227 11.989 120.337 12.3846 119.354 12.5661Z",
    fill: "url(#paint44_linear_0_1)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M130.108 106.933C129.859 106.888 129.622 106.799 129.411 106.673C129.2 106.547 129.021 106.387 128.885 106.203C128.045 107.042 127.364 107.987 126.863 109.009C127.258 109.419 127.773 109.737 128.351 109.929C128.6 108.801 129.206 107.767 130.108 106.933Z",
    fill: "url(#paint45_linear_0_1)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M114.523 89.5817C114.989 90.1073 115.213 90.7804 115.032 92.2938C115.863 92.295 116.655 92.0711 117.288 91.6554C117.31 90.6709 117.028 89.6806 116.47 88.7797C115.957 89.2235 115.273 89.505 114.523 89.5817Z",
    fill: "url(#paint46_linear_0_1)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M126.876 76.1553C126.941 75.9733 126.955 75.7793 126.917 75.5867C126.879 75.3941 126.79 75.2077 126.657 75.0406C125.868 75.0383 125.075 74.9604 124.295 74.8086C124.366 75.0141 124.369 75.2274 124.306 75.4269C125.194 75.566 126.06 75.8115 126.876 76.1553Z",
    fill: "url(#paint47_linear_0_1)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M137.178 61.6392C137.029 61.34 136.77 61.0826 136.441 60.9059C136.278 61.1984 136 61.4315 135.65 61.5693C135.778 61.8568 135.972 62.124 136.221 62.3552C136.477 62.0644 136.802 61.8213 137.178 61.6392Z",
    fill: "url(#paint48_linear_0_1)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 86.3814C154.28 86.4878 154.094 86.635 153.955 86.8126C153.817 86.9901 153.729 87.1937 153.698 87.4089C154.393 87.8896 155.023 88.4333 155.576 89.0287C155.702 88.8267 155.891 88.6593 156.125 88.5427C155.46 87.888 154.912 87.1592 154.5 86.3814Z",
    fill: "url(#paint49_linear_0_1)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M164.767 68.7014C165.159 68.2618 165.362 67.7179 165.344 67.1508C164.993 66.862 164.692 66.5336 164.451 66.1766C164.312 66.5435 164.035 66.6707 163.384 66.7667C163.96 67.353 164.427 68.0061 164.767 68.7014Z",
    fill: "url(#paint50_linear_0_1)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M135.849 41.8341C135.516 41.6105 135.131 41.4482 134.724 41.3592C134.318 41.2702 133.898 41.2567 133.497 41.3196C133.106 42.3929 132.563 43.4158 131.878 44.3676C132.325 44.4376 132.749 44.6021 133.111 44.8448C133.824 43.7203 134.747 42.7051 135.849 41.8341Z",
    fill: "url(#paint51_linear_0_1)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M130.871 32.627C131.561 32.8626 132.31 32.914 133.006 32.7737C133.24 32.407 133.544 32.0759 133.906 31.792C133.395 31.7689 133.141 31.5474 132.782 31.0155C132.263 31.6405 131.617 32.1848 130.871 32.627Z",
    fill: "url(#paint52_linear_0_1)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4193 91.8087C84.9393 92.5518 84.2791 93.198 83.4771 93.7099C83.8137 94.0937 84.2856 94.3838 84.8204 94.5356C85.6547 94.0244 86.3812 93.4052 86.9751 92.6994C86.0882 92.5485 85.6845 92.3551 85.4193 91.8087Z",
    fill: "url(#paint53_linear_0_1)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M102.184 69.66C102.372 69.2527 102.473 68.8162 102.48 68.3698C102.15 68.3509 101.825 68.4051 101.54 68.5268C101.593 68.8048 101.537 69.0836 101.38 69.3204C101.532 69.3252 101.682 69.3582 101.821 69.4169C101.96 69.4757 102.084 69.5587 102.184 69.66Z",
    fill: "url(#paint54_linear_0_1)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M121.872 107.646C121.107 106.821 120.183 106.104 119.142 105.528C118.761 106.038 118.561 106.635 118.565 107.254C119.269 107.522 119.864 107.97 120.256 108.529C120.42 108.285 120.65 108.079 120.93 107.926C121.21 107.773 121.532 107.677 121.872 107.646Z",
    fill: "url(#paint55_linear_0_1)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1574 88.8289C94.1068 88.7822 94.0686 88.7276 94.0455 88.669C94.0225 88.6103 94.0151 88.5491 94.0239 88.4897C93.6363 88.5418 93.2639 88.6402 92.918 88.782C92.9234 88.9278 92.9777 89.0724 93.075 89.1997C93.3835 88.9978 93.7567 88.8699 94.1574 88.8289Z",
    fill: "url(#paint56_linear_0_1)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M149.628 85.3041C148.696 85.3816 147.799 85.5946 146.978 85.9333C147.267 86.3627 147.686 86.7285 148.19 86.993C148.648 86.7119 149.215 86.5676 149.805 86.5819C149.661 86.3871 149.57 86.171 149.539 85.9496C149.508 85.7283 149.539 85.5076 149.628 85.3041Z",
    fill: "url(#paint57_linear_0_1)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5233 29.0598C79.3357 28.9772 79.1694 28.8626 79.0363 28.724C78.9032 28.5853 78.8064 28.4261 78.7528 28.2576C77.8633 28.7233 77.0688 29.2987 76.394 29.9658C76.5926 30.3434 76.9057 30.6768 77.3008 30.9314C77.8194 30.1458 78.5854 29.5007 79.5233 29.0598Z",
    fill: "url(#paint58_linear_0_1)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M109.018 59.6091C108.931 59.7021 108.877 59.814 108.861 59.9335C108.846 60.053 108.869 60.1759 108.93 60.2899C109.188 60.4056 109.481 60.4475 109.759 60.4088C109.873 60.1349 110.08 59.8977 110.358 59.7238C109.913 59.7598 109.457 59.7208 109.018 59.6091Z",
    fill: "url(#paint59_linear_0_1)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5723 68.5957C72.6853 69.1014 72.9914 69.5749 73.4452 69.9457C73.8821 69.9538 74.3197 70.0167 74.7427 70.1322C74.5371 69.8079 74.6054 69.5735 74.9094 69.158C74.107 69.0752 73.3174 68.8852 72.5723 68.5957Z",
    fill: "url(#paint60_linear_0_1)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M135.097 60.536C135.094 60.8671 135.221 61.1974 135.458 61.4776C135.766 61.2658 136.154 61.1458 136.565 61.135C136.586 60.822 136.528 60.5042 136.394 60.2022C135.996 60.3812 135.556 60.4944 135.097 60.536Z",
    fill: "url(#paint61_linear_0_1)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M143.86 89.1676L142.26 89.6712C142.26 89.6712 140.382 87.5572 138.453 87.3364C138.131 87.2999 137.807 87.3223 137.506 87.4019L139.106 86.8984C141.32 86.3055 143.86 89.1676 143.86 89.1676Z",
    fill: "url(#paint62_linear_0_1)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M115.712 101.848C115.445 101.921 115.164 101.958 114.877 101.959C116.859 100.349 117.063 95.1868 121.173 93.7263L121.345 93.669L121.462 93.6324C121.641 93.5824 121.827 93.5488 122.018 93.5322C118.279 95.5036 118.297 100.914 115.846 101.803L115.712 101.848Z",
    fill: "url(#paint63_linear_0_1)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M134.23 96.1638C133.932 96.258 133.615 96.313 133.291 96.3269C135.632 94.5582 135.338 88.3042 137.305 87.5973L137.383 87.5728C137.686 87.4897 138.014 87.4663 138.34 87.5044C136.856 89.2752 137.006 95.2644 134.23 96.1638Z",
    fill: "url(#paint64_linear_0_1)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M134.143 96.3456L132.538 96.8338C129.043 97.9076 125.412 93.0601 122.108 93.2978C121.918 93.3134 121.733 93.3451 121.555 93.3923L123.154 92.9039C126.32 92.0663 129.819 96.6134 133.231 96.5035C133.546 96.4876 133.853 96.4344 134.143 96.3456Z",
    fill: "url(#paint65_linear_0_1)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M99.141 95.2471C97.2581 96.1535 92.8524 93.7305 90.498 94.2747L91.5226 93.6747C93.6949 93.1646 97.6395 95.1841 99.6923 94.7985C99.8386 94.7728 99.9778 94.7308 100.105 94.6738L99.3987 95.1035L99.141 95.2471Z",
    fill: "url(#paint66_linear_0_1)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M101.236 91.6281C100.148 91.1652 99.2131 90.4693 98.5358 89.6171C98.1889 89.1803 98.1289 88.9277 98.2386 88.8263C98.6005 88.5005 100.77 89.747 101.236 91.6281Z",
    fill: "url(#paint67_linear_0_1)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M104.327 88.9584C103.493 88.5487 102.779 87.9803 102.25 87.3038C102.033 87.0024 101.991 86.8292 102.063 86.7955C102.3 86.6443 103.686 87.6241 104.327 88.9584Z",
    fill: "url(#paint68_linear_0_1)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M103.939 91.6363L103.884 91.6759C103.799 91.7275 103.708 91.7719 103.612 91.8087C103.509 91.8423 103.402 91.8703 103.294 91.8924C103.388 91.7189 103.445 91.5315 103.464 91.3379C103.532 90.7871 103.43 90.2211 103.168 89.6934C103.597 89.9103 104.051 90.0884 104.52 90.2244C104.536 90.3624 104.539 90.5004 104.527 90.6371C104.498 90.8933 104.405 91.138 104.254 91.3556C104.17 91.4649 104.064 91.5599 103.939 91.6363Z",
    fill: "url(#paint69_linear_0_1)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M107.797 89.3565C107.605 89.48 107.375 89.5567 107.128 89.5788C107.238 89.2214 107.232 88.8397 107.11 88.4717L108.146 87.7788C108.344 88.5849 108.184 89.0885 107.797 89.3565Z",
    fill: "url(#paint70_linear_0_1)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M100.139 94.5228C100.01 94.5868 99.8699 94.6339 99.722 94.6628C99.7212 94.6159 99.7762 94.5623 99.8034 94.512C100.146 93.8523 100.237 93.108 100.064 92.375C100.424 92.5247 100.802 92.6366 101.189 92.7078C101.145 93.0944 101.033 93.4695 100.855 93.8208C100.775 93.9878 100.663 94.1408 100.521 94.2736C100.41 94.3722 100.281 94.4562 100.139 94.5228Z",
    fill: "url(#paint71_linear_0_1)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M107.809 89.4198L106.772 90.1052C106.295 90.4136 105.484 90.3908 104.603 90.148C104.138 90.0169 103.688 89.8453 103.263 89.6361C102.432 89.233 101.722 88.6769 101.193 88.0162C100.977 87.7219 100.935 87.5529 101.006 87.52L102.033 86.8567C101.961 86.9032 102.003 87.0586 102.219 87.3529C102.747 88.0133 103.458 88.5682 104.289 88.9683C105.138 89.4472 106.14 89.6924 107.137 89.6653C107.388 89.6367 107.621 89.5518 107.809 89.4198Z",
    fill: "url(#paint72_linear_0_1)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M103.887 91.7412L102.844 92.4161C102.618 92.5344 102.361 92.6116 102.089 92.6431C101.818 92.6746 101.537 92.6597 101.265 92.5993C100.881 92.5303 100.506 92.4218 100.149 92.2766C99.062 91.8219 98.1297 91.1371 97.4562 90.2984C97.1103 89.8743 97.0504 89.6218 97.1598 89.5223L98.1865 88.8557C98.0772 88.9553 98.1369 89.2031 98.4829 89.6318C99.1583 90.4681 100.09 91.1511 101.176 91.6055C101.83 91.9059 102.571 92.0271 103.286 91.9502C103.393 91.9288 103.499 91.9017 103.601 91.869C103.702 91.8344 103.798 91.7916 103.887 91.7412Z",
    fill: "url(#paint73_linear_0_1)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M170.39 83.5869C168.137 83.8585 165.205 80.1394 162.689 79.9244L163.977 79.6591C166.304 79.8568 168.983 83.0449 171.156 83.3164C171.307 83.3388 171.46 83.3456 171.611 83.3367L170.716 83.5253L170.39 83.5869Z",
    fill: "url(#paint74_linear_0_1)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M173.907 80.9709C173.085 80.1918 172.521 79.251 172.279 78.2533C172.152 77.7444 172.216 77.4935 172.372 77.4349C172.875 77.2606 174.36 79.1065 173.907 80.9709Z",
    fill: "url(#paint75_linear_0_1)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M177.961 79.5561C177.358 78.9068 176.946 78.1537 176.761 77.3636C176.693 77.0215 176.753 76.8642 176.82 76.8391C177.117 76.7822 177.982 78.1309 177.961 79.5561Z",
    fill: "url(#paint76_linear_0_1)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M176.384 81.8799L176.311 81.8766C176.209 81.8986 176.102 81.9093 175.994 81.9085C175.883 81.9127 175.771 81.9076 175.659 81.8932C175.825 81.764 175.965 81.6139 176.076 81.4477C176.392 80.9791 176.557 80.4438 176.557 79.8904C176.858 80.226 177.201 80.5348 177.581 80.8107C177.521 80.9342 177.45 81.0536 177.369 81.1679C177.225 81.3875 177.023 81.5747 176.777 81.7168C176.658 81.7885 176.526 81.8436 176.384 81.8799Z",
    fill: "url(#paint77_linear_0_1)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M180.953 81.0726C180.715 81.1152 180.464 81.1037 180.224 81.0395C180.489 80.7586 180.658 80.4208 180.713 80.0585L182.004 79.7813C181.84 80.5746 181.452 80.9665 180.953 81.0726Z",
    fill: "url(#paint78_linear_0_1)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M171.59 83.2609C171.438 83.2702 171.285 83.2632 171.133 83.2401L171.281 83.1314C171.907 82.6624 172.336 82.0385 172.514 81.34C172.777 81.5858 173.077 81.8031 173.404 81.9857C173.186 82.3176 172.906 82.6163 172.574 82.8717C172.414 82.9965 172.227 83.0958 172.022 83.1652C171.885 83.2128 171.739 83.2449 171.59 83.2609Z",
    fill: "url(#paint79_linear_0_1)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M181.014 81.1148L179.722 81.3877C179.124 81.5171 178.357 81.2333 177.642 80.7261C177.263 80.4525 176.92 80.1462 176.62 79.8132C176.021 79.1763 175.612 78.4375 175.426 77.6622C175.359 77.3274 175.418 77.1733 175.49 77.1536L176.781 76.876C176.693 76.8997 176.656 77.0547 176.723 77.3895C176.907 78.163 177.315 78.9002 177.911 79.5357C178.49 80.2475 179.325 80.796 180.285 81.0954C180.526 81.1553 180.777 81.162 181.014 81.1148Z",
    fill: "url(#paint80_linear_0_1)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M176.374 81.9415L175.065 82.2236C174.792 82.2563 174.51 82.2417 174.237 82.1807C173.963 82.1198 173.703 82.0137 173.473 81.8691C173.145 81.6865 172.846 81.4692 172.583 81.2233C171.769 80.455 171.208 79.53 170.963 78.5487C170.843 78.049 170.9 77.8022 171.055 77.7492L172.353 77.4712C172.198 77.5288 172.135 77.7754 172.261 78.2754C172.501 79.2556 173.06 80.1798 173.875 80.9451C174.355 81.4336 175.004 81.7879 175.723 81.9533C175.834 81.9677 175.946 81.9728 176.057 81.9686C176.165 81.9709 176.271 81.9618 176.374 81.9415Z",
    fill: "url(#paint81_linear_0_1)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0173 84.6801L82.4322 86.436C82.2057 87.1254 76.9996 85.2331 76.1969 86.9081L76.7253 85.3991C77.0018 84.075 79.3647 84.4425 81.1491 84.7043C82.1217 84.832 82.9443 84.9442 83.0173 84.6801Z",
    fill: "url(#paint82_linear_0_1)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1612 84.5069C83.0767 84.7812 82.2616 84.6651 81.2397 84.5117C80.0095 83.2363 78.4066 81.6565 78.6487 80.8194L78.6806 80.7281C78.772 80.5817 78.9023 80.4561 79.0624 80.3601C79.2225 80.2641 79.4084 80.2001 79.607 80.1726C80.6419 81.7589 83.352 83.927 83.1612 84.5069Z",
    fill: "url(#paint83_linear_0_1)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1597 77.0177L84.5738 78.816C84.1831 80.0073 81.3005 79.6854 79.7515 80.0488C79.5535 80.0759 79.3681 80.1389 79.2084 80.2333C79.0488 80.3278 78.9188 80.4515 78.8277 80.5956L79.4139 78.8201C79.8525 77.8317 82.9259 78.2625 84.3933 77.6765C84.5755 77.6224 84.7384 77.5354 84.8707 77.4217C85.0031 77.3079 85.1017 77.17 85.1597 77.0177Z",
    fill: "url(#paint84_linear_0_1)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3658 76.8505C85.3095 77.0074 85.2125 77.1499 85.0813 77.2682C84.9502 77.3865 84.788 77.4778 84.606 77.5359C83.9254 76.1953 81.9741 74.5886 82.3333 72.1282C82.3678 71.8654 82.4275 71.6067 82.512 71.3547C82.6098 71.0575 82.7408 70.7704 82.9031 70.4969C82.6157 73.5587 85.8799 75.2496 85.3658 76.8505Z",
    fill: "url(#paint85_linear_0_1)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M89.689 65.4917L89.1022 67.3119C89.1022 67.3119 84.761 67.6033 83.1266 70.3269C82.9661 70.5951 82.8368 70.8767 82.7401 71.1681L83.327 69.3479C84.4863 65.8361 89.689 65.4917 89.689 65.4917Z",
    fill: "url(#paint86_linear_0_1)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M125.744 82.7017C124.64 82.8944 123.46 82.8228 122.363 82.4966L125.288 81.9537C125.99 82.1688 126.732 82.2743 127.47 82.2633C127.061 82.4078 126.638 82.5299 126.203 82.6289L125.744 82.7017Z",
    fill: "url(#paint87_linear_0_1)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M139.409 46.0156L138.002 47.1663C138.157 47.0198 138.289 46.8565 138.394 46.6802C139.228 45.3051 138.384 43.301 137.18 41.3416L138.592 40.2147C139.947 42.3979 140.846 44.659 139.409 46.0156Z",
    fill: "url(#paint88_linear_0_1)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M125.198 53.8273C125.254 53.6498 125.357 53.4862 125.5 53.3473C125.765 53.1195 126.088 52.9391 126.45 52.8163C127.711 52.3519 129.256 52.6048 130.373 52.4159C130.305 52.6545 130.166 52.8733 129.968 53.0545C129.013 53.9067 126.901 53.2766 125.198 53.8273Z",
    fill: "url(#paint89_linear_0_1)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M135.673 48.2787C134.502 48.5318 133.076 48.4338 131.932 48.666C131.927 48.4463 132.019 48.2374 132.194 48.0771C132.243 48.0348 132.296 47.9958 132.353 47.9604C132.522 47.8603 132.707 47.7766 132.903 47.7109C134.076 47.321 135.748 47.5049 137.062 47.2183C137.476 47.1407 137.874 47.0249 138.248 46.8731C138.144 47.0383 138.015 47.1913 137.862 47.3286C137.276 47.8124 136.516 48.1422 135.673 48.2787Z",
    fill: "url(#paint90_linear_0_1)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M131.46 51.7967L130.055 52.9229C130.256 52.7292 130.397 52.4955 130.466 52.2404C130.535 51.9826 130.57 51.7175 130.571 51.4495C130.555 50.4552 130.156 49.8247 130.672 49.3636L130.794 49.2704L132.105 48.2528C131.928 48.4238 131.834 48.6465 131.84 48.8808C131.846 49.2531 131.977 49.7159 131.981 50.2999C132.034 50.8478 131.849 51.3794 131.46 51.7967Z",
    fill: "url(#paint91_linear_0_1)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M124.923 58.6211L123.523 59.7567C124.433 58.159 123.78 57.7743 123.626 56.3116C123.548 55.325 123.602 54.8171 124.304 54.3865L125.424 53.4931C125.277 53.6422 125.171 53.8177 125.115 54.0081C125.022 54.3888 125.003 54.7835 125.06 55.1776C125.174 56.6385 125.827 57.0231 124.923 58.6211Z",
    fill: "url(#paint92_linear_0_1)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M146.338 62.582L144.39 63.3595C143.856 60.5218 144.765 58.9557 146.457 58.3399C146.765 58.2304 147.089 58.151 147.422 58.1032C146.389 58.9228 145.926 60.3689 146.338 62.582Z",
    fill: "url(#paint93_linear_0_1)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M117.957 50.0392L116.538 51.7984C116.538 51.7984 113.848 53.6871 108.269 55.4179L108.18 55.4413C107.746 55.5537 107.366 55.7634 107.08 56.0479L108.429 54.3813C108.706 54.0484 109.113 53.8048 109.589 53.6862C115.241 51.9449 117.957 50.0392 117.957 50.0392Z",
    fill: "url(#paint94_linear_0_1)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M100.375 74.0689L99.0093 75.758L98.9058 75.8813C98.3607 76.492 97.2957 76.5947 95.9258 76.7292L97.3513 74.9652C98.0272 74.9217 98.6917 74.8231 99.3352 74.671C99.7587 74.5714 100.123 74.3604 100.375 74.0689Z",
    fill: "url(#paint95_linear_0_1)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M100.554 73.94C100.297 74.241 99.9262 74.4587 99.4949 74.5614C99.5038 74.0541 99.45 73.5438 99.3344 73.0385C99.0025 71.4179 97.9498 69.9953 98.9355 68.6907L99.0021 68.6088C99.2754 68.2933 99.611 68.0203 99.9958 67.8003C99.8488 68.8463 100.529 69.9731 100.787 71.2172C101.064 72.6086 100.964 73.435 100.554 73.94Z",
    fill: "url(#paint96_linear_0_1)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M110.811 62.3753L109.446 64.0497L109.321 64.2032C108.449 65.1455 106.124 65.5724 103.803 66.1813C102.526 66.4715 101.321 66.9179 100.228 67.5062C99.85 67.7182 99.5208 67.9811 99.2526 68.2849L100.683 66.5315C101.303 65.8006 102.635 65.1062 105.222 64.4366C106.74 64.1126 108.217 63.6931 109.642 63.1815C110.105 62.9907 110.505 62.7154 110.811 62.3753Z",
    fill: "url(#paint97_linear_0_1)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M111.062 62.0571C110.746 62.4057 110.336 62.6857 109.862 62.8769C109.441 61.0744 105.581 58.037 106.751 56.4249L106.822 56.3299C107.11 56.0377 107.493 55.8224 107.931 55.707L108.02 55.6831C108.431 57.5741 111.794 60.3077 111.296 61.6701C111.243 61.8097 111.164 61.9402 111.062 62.0571Z",
    fill: "url(#paint98_linear_0_1)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M137.894 104.019L134.807 104.002L134.574 103.992C133.41 103.942 132.466 103.178 131.219 102.202L134.438 102.22C135.02 102.714 135.655 103.169 136.335 103.577C136.793 103.847 137.339 104.002 137.894 104.019Z",
    fill: "url(#paint99_linear_0_1)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M137.941 103.823C137.392 103.806 136.852 103.647 136.396 103.371C136.993 103.062 137.545 102.701 138.043 102.293C139.687 101.002 140.507 99.2902 142.773 99.2603L142.917 99.2669C143.494 99.2862 144.07 99.3829 144.621 99.5532C143.298 100.09 142.514 101.334 141.27 102.316C139.895 103.406 138.864 103.837 137.941 103.823Z",
    fill: "url(#paint100_linear_0_1)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M81.481 57.3228L81.3316 58.8712C81.586 58.7114 81.7944 58.5069 81.9438 58.2705C82.0932 58.034 82.1802 57.7709 82.1995 57.4975C82.2207 57.2227 82.1972 56.9442 82.1296 56.6695C81.9728 56.9256 81.7519 57.1481 81.481 57.3228Z",
    fill: "url(#paint101_linear_0_1)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3966 49.4843C80.4018 49.7 80.4297 49.9162 80.4799 50.1304C81.1884 48.9152 83.4747 48.8486 85.0216 47.838C85.7551 47.3979 86.2426 46.7322 86.387 45.9735L86.3845 45.8256C86.3955 45.5934 86.3672 45.3588 86.3004 45.1286C86.0367 45.6066 85.6423 46.0213 85.1466 46.342C83.3134 47.5336 80.4058 47.3916 80.3966 49.4843Z",
    fill: "url(#paint102_linear_0_1)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0273 50.9592C80.0012 51.2741 80.0293 51.5936 80.1107 51.9081C80.3913 53.1261 81.953 55.0129 82.3251 56.6273C82.393 56.9027 82.4166 57.1819 82.3953 57.4575L82.5458 55.9003C82.6932 54.1493 80.5851 51.7883 80.2557 50.3555C80.2527 50.3349 80.2523 50.3143 80.2547 50.294C80.2037 50.0749 80.1754 49.8538 80.1703 49.6332L80.0273 50.9592Z",
    fill: "url(#paint103_linear_0_1)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3126 37.6752L80.1805 39.1126L80.1833 39.2804C80.1841 39.327 80.1849 39.3736 80.1856 39.4202C80.3024 40.7248 82.2919 41.2679 83.4293 41.8976C84.9703 42.6389 86.2498 43.7594 86.582 44.9388C86.649 45.1708 86.6773 45.4072 86.6663 45.6412L86.8081 44.1157C86.8901 42.6852 85.4157 41.2577 83.571 40.3674C82.6024 39.8246 81.0157 39.3513 80.4979 38.4148C80.4028 38.2448 80.345 38.0637 80.3272 37.8807C80.3094 37.8194 80.3082 37.7495 80.3126 37.6752Z",
    fill: "url(#paint104_linear_0_1)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M80.583 37.4067L80.5835 37.4342C80.5847 37.5074 80.5859 37.5761 80.5872 37.6493C80.6049 37.8292 80.6625 38.007 80.7572 38.174C81.3762 37.3282 82.7775 36.7421 83.6943 36.4176C85.8372 35.6591 90.0905 34.5205 90.2373 33.022C90.2514 32.7596 90.1546 32.4951 89.9634 32.273C88.8159 33.4059 85.6194 34.2905 83.8243 34.9137C82.659 35.3276 80.7173 36.1592 80.583 37.4067Z",
    fill: "url(#paint105_linear_0_1)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8436 78.1427C62.9462 78.2759 62.9841 78.4369 62.9507 78.5973C62.3201 78.6168 61.6918 78.7269 61.0958 78.9223C61.0962 78.7714 61.0331 78.6281 60.9167 78.5153C61.5277 78.2854 62.1843 78.1585 62.8436 78.1427Z",
    fill: "url(#paint106_linear_0_1)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1577 63.0851C25.5272 62.947 25.8448 62.7245 26.0696 62.4462C26.16 62.5401 26.295 62.5985 26.4446 62.6085C26.2199 62.9292 25.8952 63.1989 25.506 63.3884C25.3587 63.3143 25.2389 63.21 25.1577 63.0851Z",
    fill: "url(#paint107_linear_0_1)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M40.748 67.201C41.4508 67.0183 42.1114 66.7267 42.6921 66.3427C42.9392 66.5725 43.0802 66.8677 43.0931 67.182C42.5099 67.5867 41.8595 67.9198 41.1646 68.1696C41.2098 67.6615 41.136 67.4062 40.748 67.201Z",
    fill: "url(#paint108_linear_0_1)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4023 35.464C44.8644 35.7611 44.3152 35.7632 43.4417 35.6131C43.7136 34.6604 43.7122 33.6838 43.4377 32.7597C44.1205 32.8431 44.8333 32.723 45.4461 32.4214C45.6899 33.414 45.675 34.4496 45.4023 35.464Z",
    fill: "url(#paint109_linear_0_1)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4762 62.7485C18.3871 62.5726 18.3481 62.3804 18.3618 62.1855C18.3756 61.9906 18.4419 61.7979 18.5559 61.6208C19.3504 61.5575 20.1387 61.4179 20.9044 61.2049C20.871 61.414 20.9045 61.6232 21.0016 61.812C20.1141 62.0206 19.2624 62.3365 18.4762 62.7485Z",
    fill: "url(#paint110_linear_0_1)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M107.91 21.166C108.158 21.1752 108.398 21.2287 108.611 21.3226C108.824 21.4165 109.006 21.5485 109.143 21.7092C108.779 22.3304 108.504 22.9791 108.324 23.6422C108.104 23.5258 107.847 23.4586 107.578 23.4468C107.829 22.6969 107.941 21.9281 107.91 21.166Z",
    fill: "url(#paint111_linear_0_1)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4232 52.9967C90.9983 53.9349 91.3599 54.9586 91.4915 56.0211C90.6818 56.1271 89.8658 56.0544 89.1299 55.8109C89.229 55.1311 88.9779 54.6539 88.5174 53.9467C88.8929 53.9086 89.2585 53.8036 89.5881 53.6393C89.9177 53.4751 90.2029 53.2556 90.4232 52.9967Z",
    fill: "url(#paint112_linear_0_1)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M118.408 54.544C118.604 55.4653 118.482 56.429 118.055 57.3305C117.36 57.491 116.633 57.4565 115.995 57.2328C116.427 56.3457 116.536 55.3917 116.31 54.4887C117.154 54.7763 117.673 54.8422 118.408 54.544Z",
    fill: "url(#paint113_linear_0_1)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9668 61.9836C70.8003 61.8669 70.6013 61.784 70.3845 61.741C70.7169 61.4801 71.0069 61.1855 71.2463 60.8654C71.4695 60.8609 71.6817 60.9236 71.8423 61.0416C71.5959 61.3809 71.3019 61.6971 70.9668 61.9836Z",
    fill: "url(#paint114_linear_0_1)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5501 42.8336C32.1842 43.2849 33.0705 43.5101 35.199 43.3816C35.0497 44.1612 34.598 44.8969 33.9107 45.4797C32.5495 45.4726 31.2351 45.1832 30.0911 44.6388C30.795 44.169 31.3069 43.5356 31.5501 42.8336Z",
    fill: "url(#paint115_linear_0_1)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7876 100.052C50.4855 100.153 50.222 100.325 50.0312 100.544C49.9982 100.505 49.9558 100.472 49.9062 100.448C49.8567 100.423 49.8011 100.408 49.7426 100.401C49.9408 100.145 50.22 99.936 50.5482 99.7969C50.654 99.863 50.7362 99.9506 50.7876 100.052Z",
    fill: "url(#paint116_linear_0_1)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4767 68.0121C98.5253 68.1901 98.5219 68.3775 98.4668 68.5597C98.4116 68.7419 98.3062 68.9139 98.1587 69.0622C97.4538 68.7912 96.6714 68.6602 95.8718 68.6792C96.0829 68.3303 96.14 67.9396 96.0331 67.5762C96.8863 67.5823 97.7177 67.7307 98.4767 68.0121Z",
    fill: "url(#paint117_linear_0_1)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1248 77.0102C75.7055 77.0785 75.2785 77.073 74.8739 76.9941C74.4692 76.9152 74.0968 76.7649 73.7828 76.5537C74.0685 75.4351 74.1908 74.3017 74.1472 73.177C74.5744 73.289 75.0376 73.3089 75.492 73.2349C75.4618 74.5239 75.6751 75.7968 76.1248 77.0102Z",
    fill: "url(#paint118_linear_0_1)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2266 22.4327C48.8072 22.5022 48.3798 22.4973 47.9748 22.4184C47.5699 22.3395 47.1975 22.1884 46.8844 21.9762C47.1728 20.8562 47.2951 19.7211 47.2486 18.595C47.6757 18.7076 48.1391 18.7275 48.5935 18.6528C48.5628 19.9434 48.7762 21.2178 49.2266 22.4327Z",
    fill: "url(#paint119_linear_0_1)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2915 94.8816C91.0862 95.0402 90.9221 95.2306 90.8101 95.44C90.4942 95.0985 90.1194 94.7969 89.6961 94.5438C89.7358 94.3242 89.8747 94.1196 90.0851 93.9705C90.5344 94.2307 90.9395 94.5367 91.2915 94.8816Z",
    fill: "url(#paint120_linear_0_1)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3741 47.1407C80.1717 47.1469 80.9281 47.3662 81.528 47.7649C81.5589 48.2225 81.676 48.669 81.8751 49.0891C81.3612 48.9399 80.9981 49.0598 80.3647 49.4724C80.1976 48.6479 79.863 47.8601 79.3741 47.1407Z",
    fill: "url(#paint121_linear_0_1)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M54.013 82.8323C53.841 83.1482 53.5494 83.3065 53.0758 83.5139C52.4754 82.601 51.6721 81.7935 50.7036 81.1296C51.0488 80.9534 51.3189 80.6918 51.4708 80.3865C52.5353 81.0329 53.4022 81.8669 54.013 82.8323Z",
    fill: "url(#paint122_linear_0_1)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05058 69.3887C8.81657 69.5488 8.52349 69.6386 8.22587 69.6415C8.1303 68.9002 7.86916 68.187 7.45479 67.5358C7.73371 67.4913 7.99188 67.3735 8.18797 67.2014C8.6706 67.8626 8.96472 68.6084 9.05058 69.3887Z",
    fill: "url(#paint123_linear_0_1)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7388 78.7023C33.6576 78.5399 33.533 78.396 33.3735 78.2807C33.2139 78.1654 33.0233 78.0814 32.8148 78.0344C33.5498 77.2379 34.415 76.5246 35.384 75.9165C35.8585 76.0893 36.2589 76.3663 36.5431 76.7184C35.4274 77.1797 34.4607 77.8636 33.7388 78.7023Z",
    fill: "url(#paint124_linear_0_1)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4867 66.3899C85.4724 66.534 85.4116 66.675 85.3105 66.7984C85.2095 66.9219 85.0718 67.0234 84.9113 67.0929C84.581 67.0367 84.292 66.8882 84.093 66.6723C84.26 66.3408 84.3123 65.9838 84.244 65.6416C84.5857 65.9607 85.0086 66.2153 85.4867 66.3899Z",
    fill: "url(#paint125_linear_0_1)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1684 77.0224C90.2189 76.8266 90.3312 76.6419 90.494 76.4867C90.6567 76.3315 90.8643 76.2113 91.0957 76.1383C91.5283 76.2667 91.8869 76.5113 92.115 76.8338C91.8177 77.2656 91.6704 77.7489 91.6899 78.2288C91.2947 77.742 90.7772 77.3316 90.1684 77.0224Z",
    fill: "url(#paint126_linear_0_1)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2615 67.3588C70.0708 67.0518 69.9533 66.7153 69.915 66.366C70.1799 66.3318 70.4466 66.3554 70.6877 66.4342C70.6691 66.6567 70.7401 66.8734 70.8899 67.0514C70.7667 67.0633 70.6465 67.0969 70.5379 67.1501C70.4293 67.2032 70.3349 67.2745 70.2615 67.3588Z",
    fill: "url(#paint127_linear_0_1)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0799 22.0011C88.661 21.3101 88.3994 20.5568 88.3073 19.7755C88.9032 19.7031 89.5021 19.7588 90.0437 19.9369C90.001 20.4308 90.1561 20.9123 90.4858 21.3091C90.2099 21.3365 89.9408 21.4127 89.6978 21.5323C89.4549 21.6519 89.2439 21.812 89.0799 22.0011Z",
    fill: "url(#paint128_linear_0_1)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M61.206 91.7999C61.4996 91.9581 61.8613 92.0188 62.2222 91.9706C62.0075 92.4126 61.7053 92.8267 61.3282 93.1954C61.0176 93.0972 60.7395 92.9463 60.5113 92.752C60.8241 92.4766 61.0615 92.1512 61.206 91.7999Z",
    fill: "url(#paint129_linear_0_1)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1145 26.0907C63.3934 26.7275 63.4498 27.4247 63.2779 28.1086C62.7916 28.282 62.2582 28.3227 61.7617 28.2244C61.9436 27.5498 61.8797 26.8593 61.5777 26.2389C61.8211 26.3182 62.0887 26.3461 62.3568 26.3203C62.6248 26.2944 62.8851 26.2155 63.1145 26.0907Z",
    fill: "url(#paint130_linear_0_1)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3052 75.0923C57.2841 75.4261 57.3884 75.7509 57.6045 76.024C57.5279 76.0394 57.4553 76.0676 57.3914 76.1068C57.3274 76.1459 57.2737 76.1951 57.2338 76.251C56.9675 75.9629 56.8115 75.615 56.7834 75.2468C56.9412 75.1614 57.1207 75.1083 57.3052 75.0923Z",
    fill: "url(#paint131_linear_0_1)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7059 48.0033C45.5453 47.968 45.3748 47.961 45.206 47.983C45.0371 48.0049 44.8738 48.0551 44.7269 48.1304C44.5554 47.4201 44.516 46.687 44.61 45.9541C44.9901 45.8119 45.4055 45.7545 45.8099 45.7882C45.5317 46.5188 45.4958 47.283 45.7059 48.0033Z",
    fill: "url(#paint132_linear_0_1)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2407 32.3101C84.5913 32.3469 84.9098 32.4772 85.1474 32.6809C85.1307 32.887 85.155 33.0917 85.2192 33.2873C84.9983 33.2029 84.8309 33.2377 84.5212 33.3979C84.5034 33.0213 84.4086 32.6538 84.2407 32.3101Z",
    fill: "url(#paint133_linear_0_1)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8039 12.1299C80.4336 12.3355 81.1877 12.3166 82.7837 11.7857C82.9102 12.3913 82.7906 13.0264 82.4426 13.5973C81.3983 13.8691 80.3029 13.9248 79.2593 13.7591C79.6488 13.2668 79.8398 12.6953 79.8039 12.1299Z",
    fill: "url(#paint134_linear_0_1)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M103.915 55.3601C103.917 55.0989 103.824 54.8479 103.647 54.6387C103.706 54.6235 103.762 54.5989 103.81 54.5663C103.859 54.5338 103.9 54.494 103.93 54.4494C104.15 54.6697 104.285 54.9392 104.322 55.2276C104.201 55.2998 104.061 55.3456 103.915 55.3601Z",
    fill: "url(#paint135_linear_0_1)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0455 48.5581C98.7823 48.5972 98.5163 48.5611 98.294 48.4561C98.6446 47.8292 98.8559 47.1635 98.9175 46.491C99.1484 46.5588 99.4058 46.561 99.6488 46.4972C99.6301 47.2017 99.4244 47.9045 99.0455 48.5581Z",
    fill: "url(#paint136_linear_0_1)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M112.134 63.5996C111.93 63.8273 111.644 63.9996 111.32 64.0906C111.107 64.0059 110.878 63.9497 110.639 63.9239C110.831 63.8021 110.869 63.6706 110.848 63.4021C111.256 63.5246 111.691 63.5913 112.134 63.5996Z",
    fill: "url(#paint137_linear_0_1)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1178 37.8412C73.4292 37.7074 73.7688 37.6291 74.1124 37.612C74.456 37.5948 74.7952 37.6392 75.1059 37.742C75.214 38.6585 75.456 39.5545 75.827 40.4114C75.4561 40.4076 75.084 40.4815 74.7466 40.626C74.3861 39.627 73.8369 38.688 73.1178 37.8412Z",
    fill: "url(#paint138_linear_0_1)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8463 59.0918C100.413 59.4523 100.837 59.9386 101.074 60.4982C100.797 60.8048 100.407 61.0323 99.9664 61.1431C99.7402 60.5886 99.3159 60.1103 98.7455 59.7669C98.9784 59.7364 99.2017 59.6585 99.3944 59.5404C99.587 59.4222 99.7425 59.2679 99.8463 59.0918Z",
    fill: "url(#paint139_linear_0_1)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9557 69.3902C60.1946 69.1087 59.5844 68.6244 59.2194 68.0121C60.0718 67.7231 60.8037 67.2219 61.3051 66.5839C62.0403 66.8261 62.6967 67.1926 63.2333 67.6607C62.3525 68.1178 61.5789 68.7053 60.9557 69.3902Z",
    fill: "url(#paint140_linear_0_1)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3002 77.4047C83.8344 77.2278 83.4157 76.9833 83.0634 76.6824C83.3078 76.4957 83.6033 76.3607 83.9212 76.2905C84.0969 76.5094 84.3609 76.6696 84.6715 76.7459C84.5553 76.8295 84.4616 76.9319 84.3974 77.0459C84.3332 77.1598 84.3 77.2824 84.3002 77.4047Z",
    fill: "url(#paint141_linear_0_1)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M110.954 85.4096C110.715 85.4941 110.453 85.5142 110.209 85.4667C110.308 85.2584 110.322 85.0339 110.25 84.8273C110.472 84.7382 110.711 84.6855 110.953 84.6724C110.895 84.9189 110.895 85.1693 110.954 85.4096Z",
    fill: "url(#paint142_linear_0_1)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9049 49.5102C68.6959 50.0062 68.7157 50.5361 68.9607 50.9972C67.9732 50.97 67.0085 50.8089 66.1057 50.5207C66.1708 50.0404 66.3613 49.5705 66.6643 49.1431C67.3577 49.4018 68.1232 49.5273 68.9049 49.5102Z",
    fill: "url(#paint143_linear_0_1)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5175 42.7684C91.6092 43.0454 91.608 43.342 91.514 43.6281C91.42 43.9143 91.2366 44.18 90.9821 44.3984C90.2909 44.4745 89.6032 44.3596 89.03 44.0724C89.079 43.3593 88.8815 42.662 88.4601 42.0603C89.3972 42.4651 90.4371 42.7059 91.5175 42.7684Z",
    fill: "url(#paint144_linear_0_1)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M112.688 45.655C112.718 44.5687 112.625 44.0183 112.115 43.2297C112.312 43.2012 112.501 43.1404 112.671 43.0513C112.842 42.9622 112.99 42.8467 113.106 42.7121C113.721 43.4889 114.046 44.4012 114.045 45.3486C113.626 45.5424 113.158 45.648 112.688 45.655Z",
    fill: "url(#paint145_linear_0_1)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M101.654 81.4596C101.874 81.7677 102.174 82.0301 102.535 82.2297C101.717 82.5534 100.949 82.9637 100.254 83.4492C99.8339 83.3387 99.4918 83.0995 99.2966 82.78C100.021 82.2679 100.812 81.8246 101.654 81.4596Z",
    fill: "url(#paint146_linear_0_1)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5956 14.6858C69.4691 14.7935 69.371 14.9207 69.308 15.0588C69.2449 15.1969 69.2184 15.3426 69.2303 15.4859C68.3077 15.3221 67.4281 15.0477 66.6193 14.6713C66.6535 14.3211 66.8052 13.9793 67.0577 13.6835C67.7667 14.1993 68.6419 14.545 69.5956 14.6858Z",
    fill: "url(#paint147_linear_0_1)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6743 86.8922C77.2458 87.401 77.0625 88.0409 77.3181 89.4583C76.506 89.4853 75.7216 89.2994 75.0812 88.9282C75.0089 88.003 75.2328 87.0631 75.7316 86.1986C76.2552 86.6 76.9372 86.8435 77.6743 86.8922Z",
    fill: "url(#paint148_linear_0_1)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3912 74.6914C65.3198 74.5214 65.2963 74.3383 65.3224 74.1551C65.3484 73.9719 65.4234 73.793 65.542 73.6309C66.2956 73.6048 67.0485 73.5071 67.7852 73.3398C67.7284 73.5363 67.736 73.7381 67.8073 73.9247C66.9668 74.0832 66.1523 74.3416 65.3912 74.6914Z",
    fill: "url(#paint149_linear_0_1)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0408 61.3994C55.1692 61.1132 55.4061 60.8629 55.7155 60.6864C55.8884 60.9567 56.1693 61.1675 56.515 61.2863C56.4064 61.5609 56.2326 61.8184 56.0039 62.0437C55.7405 61.7779 55.4136 61.5592 55.0408 61.3994Z",
    fill: "url(#paint150_linear_0_1)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9226 85.2444C40.1417 85.3378 40.3297 85.4705 40.4735 85.6332C40.6172 85.796 40.7132 85.9848 40.7545 86.1863C40.1046 86.6602 39.5208 87.1912 39.0152 87.7686C38.8822 87.5824 38.6898 87.4307 38.4568 87.3283C39.0682 86.6917 39.5625 85.989 39.9226 85.2444Z",
    fill: "url(#paint151_linear_0_1)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4545 68.978C29.0493 68.5767 28.8235 68.0716 28.8108 67.5378C29.1386 67.2552 29.4153 66.937 29.6317 66.5938C29.7864 66.9345 30.0634 67.0456 30.7044 67.1156C30.1725 67.6849 29.7505 68.3135 29.4545 68.978Z",
    fill: "url(#paint152_linear_0_1)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3425 42.7386C55.6531 42.5177 56.0158 42.3531 56.4044 42.2567C56.793 42.1603 57.1976 42.1346 57.5887 42.1814C58.0214 43.1798 58.5991 44.126 59.31 45.0009C58.8823 45.0806 58.4803 45.2486 58.1436 45.4883C57.3964 44.4517 56.4519 43.5245 55.3425 42.7386Z",
    fill: "url(#paint153_linear_0_1)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6931 33.934C59.0438 34.1774 58.3288 34.2489 57.6536 34.1379C57.4104 33.7991 57.1024 33.4961 56.7402 33.2393C57.2293 33.2018 57.461 32.9852 57.7776 32.4723C58.3078 33.0461 58.9547 33.5397 59.6931 33.934Z",
    fill: "url(#paint154_linear_0_1)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M105.068 87.9856C105.569 88.6707 106.238 89.2591 107.037 89.7166C106.733 90.0886 106.293 90.3764 105.786 90.5359C104.956 90.0801 104.224 89.5192 103.616 88.8726C104.462 88.7031 104.841 88.5084 105.068 87.9856Z",
    fill: "url(#paint155_linear_0_1)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3085 67.7484C88.1035 67.3712 87.9833 66.9636 87.9533 66.544C88.2736 66.516 88.592 66.5569 88.8762 66.6625C88.8388 66.9257 88.9077 67.1861 89.0726 67.404C88.9253 67.4132 88.7803 67.4489 88.6482 67.5085C88.516 67.5681 88.3999 67.65 88.3085 67.7484Z",
    fill: "url(#paint156_linear_0_1)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7211 85.4856C96.7672 85.44 96.8009 85.3873 96.82 85.3313C96.8391 85.2753 96.843 85.2174 96.8315 85.1616C97.2057 85.1988 97.5678 85.2803 97.9067 85.4034C97.9091 85.5412 97.8644 85.6792 97.7778 85.8023C97.4717 85.6213 97.1073 85.5121 96.7211 85.4856Z",
    fill: "url(#paint157_linear_0_1)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4176 84.0566C45.3154 84.1012 46.1866 84.2746 46.9914 84.5688C46.7359 84.9828 46.3535 85.3407 45.8837 85.6056C45.4303 85.3546 44.8792 85.2358 44.3137 85.2674C44.4421 85.0793 44.5181 84.8726 44.5361 84.6629C44.5541 84.4532 44.5135 84.2459 44.4176 84.0566Z",
    fill: "url(#paint158_linear_0_1)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M107.705 28.8172C107.882 28.7336 108.037 28.6205 108.158 28.4859C108.279 28.3512 108.365 28.1983 108.408 28.038C109.29 28.449 110.087 28.9663 110.773 29.5735C110.601 29.9352 110.316 30.2588 109.948 30.5107C109.406 29.7871 108.633 29.2033 107.705 28.8172Z",
    fill: "url(#paint159_linear_0_1)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M81.439 58.5357C81.5272 58.6209 81.5847 58.7249 81.6058 58.8373C81.6268 58.9497 81.6106 59.0665 81.5588 59.1759C81.3181 59.2931 81.0403 59.3417 80.7721 59.3135C80.6488 59.0584 80.4382 58.8407 80.1638 58.6849C80.5914 58.7053 81.0253 58.6546 81.439 58.5357Z",
    fill: "url(#paint160_linear_0_1)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M116.107 65.7402C116.025 66.2208 115.756 66.6767 115.34 67.0404C114.922 67.0615 114.506 67.1343 114.106 67.2562C114.286 66.9439 114.209 66.7249 113.896 66.3423C114.661 66.2396 115.408 66.0362 116.107 65.7402Z",
    fill: "url(#paint161_linear_0_1)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9842 60.2964C57.0037 60.6081 56.8984 60.9229 56.684 61.194C56.3756 61.0041 55.9946 60.9032 55.5962 60.9058C55.5598 60.6117 55.5999 60.3108 55.7138 60.0222C56.1076 60.1785 56.5385 60.2715 56.9842 60.2964Z",
    fill: "url(#paint162_linear_0_1)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2661 89.5462C64.5653 89.6254 64.8805 89.6673 65.2012 89.6703C62.798 88.0809 62.7611 82.1943 60.7833 81.5912L60.705 81.5705C60.4007 81.5018 60.0766 81.49 59.7568 81.536C61.3138 83.154 61.4794 88.7873 64.2661 89.5462Z",
    fill: "url(#paint163_linear_0_1)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M92.324 91.6845C94.1562 92.5045 98.1912 90.0423 100.449 90.4996L99.4465 89.9504C97.3625 89.5207 93.7415 91.5807 91.7775 91.2676C91.6376 91.247 91.5035 91.2105 91.3797 91.1592L92.0722 91.5533L92.324 91.6845Z",
    fill: "url(#paint164_linear_0_1)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1781 88.3575C91.2064 87.888 92.0736 87.2039 92.6841 86.3807C92.9968 85.9587 93.0417 85.7191 92.9305 85.627C92.5639 85.3315 90.5312 86.5722 90.1781 88.3575Z",
    fill: "url(#paint165_linear_0_1)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1595 85.9524C87.9446 85.5408 88.6049 84.9837 89.0817 84.3305C89.2756 84.04 89.3071 83.8757 89.236 83.8461C88.9992 83.7112 87.7098 84.6764 87.1595 85.9524Z",
    fill: "url(#paint166_linear_0_1)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6706 88.4576L87.7271 88.4931C87.8134 88.5389 87.9054 88.5778 88.0018 88.6094C88.1051 88.6378 88.211 88.6608 88.3188 88.6782C88.2176 88.5181 88.1513 88.3437 88.1226 88.1623C88.0266 87.6468 88.0974 87.1116 88.3281 86.6074C87.9168 86.8247 87.4798 87.0062 87.025 87.1486C87.0164 87.2788 87.0214 87.4086 87.0398 87.5368C87.0822 87.7767 87.1867 88.0037 87.3465 88.2035C87.4342 88.3037 87.5438 88.3897 87.6706 88.4576Z",
    fill: "url(#paint167_linear_0_1)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9377 86.4465C84.1327 86.5566 84.3636 86.6215 84.6073 86.6347C84.4808 86.3022 84.4671 85.9432 84.5676 85.5935L83.5117 84.9745C83.3587 85.7383 83.5421 86.2066 83.9377 86.4465Z",
    fill: "url(#paint168_linear_0_1)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3939 91.0419C91.5237 91.098 91.6642 91.1379 91.8109 91.1604C91.8093 91.1164 91.7524 91.0677 91.7231 91.0213C91.3527 90.4118 91.2246 89.7149 91.3555 89.0205C91.0102 89.1725 90.6449 89.2894 90.2686 89.3683C90.3317 89.7304 90.4617 90.0795 90.6545 90.4042C90.7412 90.5587 90.8599 90.699 91.0059 90.8194C91.1203 90.9087 91.251 90.9836 91.3939 91.0419Z",
    fill: "url(#paint169_linear_0_1)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8854 86.5003L84.9117 87.1165C85.3839 87.3935 86.157 87.3473 86.9859 87.091C87.4235 86.953 87.844 86.7771 88.2398 86.5665C89.012 86.1602 89.6618 85.613 90.1327 84.9726C90.3236 84.6879 90.3547 84.5268 90.2846 84.4979L89.2697 83.9022C89.3402 83.944 89.3087 84.0922 89.1178 84.3769C88.6482 85.0171 87.9979 85.5631 87.2247 85.9665C86.4381 86.445 85.4939 86.7072 84.5409 86.7118C84.2988 86.6924 84.0722 86.6193 83.8854 86.5003Z",
    fill: "url(#paint170_linear_0_1)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6725 88.5486L88.7057 89.154C88.9285 89.2587 89.1784 89.3238 89.4398 89.3453C89.7012 89.3667 89.9687 89.3441 90.2258 89.2788C90.5896 89.2019 90.9427 89.088 91.2766 88.94C92.2931 88.4775 93.1495 87.8024 93.7502 86.9899C94.0591 86.5788 94.1032 86.3387 93.9935 86.2481L92.9766 85.65C93.0863 85.7406 93.042 85.9765 92.7333 86.3919C92.1307 87.2021 91.2747 87.8755 90.2595 88.3377C89.6499 88.6412 88.9464 88.7783 88.2589 88.7276C88.1549 88.7106 88.0529 88.6882 87.9533 88.6606C87.8548 88.631 87.7608 88.5935 87.6725 88.5486Z",
    fill: "url(#paint171_linear_0_1)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9333 36.956C80.0466 38.41 85.0248 37.4493 86.744 38.7042L86.1807 37.7993C84.5921 36.6449 80.2451 37.3706 78.7196 36.3433C78.6103 36.2701 78.513 36.1862 78.4297 36.0933L78.8135 36.7271L78.9333 36.956Z",
    fill: "url(#paint172_linear_0_1)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7125 33.0332C79.8379 32.9653 80.9384 32.6523 81.8951 32.1278C82.3814 31.8582 82.5533 31.6548 82.5012 31.5361C82.344 31.1545 79.956 31.5639 78.7125 33.0332Z",
    fill: "url(#paint173_linear_0_1)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1894 29.7384C78.0761 29.6386 78.9325 29.3663 79.6831 28.9456C80.0033 28.7566 80.1094 28.6303 80.0699 28.5657C79.9671 28.3623 78.3567 28.7799 77.1894 29.7384Z",
    fill: "url(#paint174_linear_0_1)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3467 32.1815L76.3757 32.232C76.4261 32.3054 76.485 32.3744 76.5517 32.4382C76.6215 32.5022 76.7 32.5595 76.7859 32.6092C76.7865 32.4278 76.8218 32.2457 76.8904 32.0695C77.0911 31.5583 77.447 31.0892 77.924 30.7073C77.4532 30.7672 76.9789 30.7843 76.5101 30.7585C76.4394 30.8796 76.3806 31.0046 76.3344 31.1323C76.241 31.367 76.2095 31.6122 76.2421 31.8511C76.2567 31.9658 76.2919 32.0771 76.3467 32.1815Z",
    fill: "url(#paint175_linear_0_1)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9947 28.9537C74.1061 29.1227 74.2722 29.2628 74.4769 29.3604C74.5423 29.0102 74.721 28.6742 74.995 28.3862L74.4918 27.4316C73.8949 28.0882 73.8029 28.587 73.9947 28.9537Z",
    fill: "url(#paint176_linear_0_1)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3517 35.9081C78.4388 36.0048 78.5405 36.0922 78.6546 36.1684L78.6484 36.0051C78.6607 35.3069 78.9326 34.6143 79.4292 34.0162C79.0555 34.0347 78.6833 34.0153 78.3215 33.9585C78.178 34.3167 78.099 34.6865 78.0871 35.0562C78.082 35.2307 78.1091 35.4031 78.1674 35.568C78.2076 35.6889 78.2697 35.8035 78.3517 35.9081Z",
    fill: "url(#paint177_linear_0_1)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0737 29.094L74.6348 29.9837C74.8926 30.3822 75.5869 30.6268 76.4425 30.6837C76.8978 30.7082 77.3584 30.6918 77.8156 30.6349C78.7003 30.5361 79.5547 30.2667 80.3035 29.8504C80.6228 29.6634 80.7286 29.5385 80.6893 29.4746L80.1281 28.5849C80.1675 28.6488 80.0617 28.7737 79.7423 28.9607C78.9853 29.3794 78.1214 29.6482 77.228 29.743C76.2894 29.8979 75.3324 29.8053 74.5047 29.4795C74.3201 29.3841 74.1718 29.2515 74.0737 29.094Z",
    fill: "url(#paint178_linear_0_1)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4121 32.3487L76.9747 33.2612C77.1127 33.4328 77.2944 33.5782 77.5089 33.6885C77.7234 33.7988 77.9664 33.8718 78.2232 33.9031C78.5685 33.9571 78.9237 33.9755 79.2804 33.9579C80.4049 33.8946 81.5052 33.5828 82.4585 33.0576C82.9441 32.7895 83.1157 32.5873 83.0637 32.4692L82.5018 31.5735C82.554 31.6957 82.3822 31.8938 81.8966 32.1618C80.9485 32.674 79.8612 32.98 78.7496 33.0473C78.0592 33.1064 77.378 32.9834 76.8106 32.6972C76.7271 32.6497 76.6507 32.5948 76.5828 32.5335C76.5189 32.4764 76.4618 32.4145 76.4121 32.3487Z",
    fill: "url(#paint179_linear_0_1)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M24.828 83.1598C26.9896 83.3487 29.5892 79.7397 31.9764 79.46L30.7351 79.2479C28.5269 79.5053 26.1409 82.6042 24.0834 82.9268C23.9403 82.9526 23.7949 82.9637 23.6506 82.9598L24.5139 83.1113L24.828 83.1598Z",
    fill: "url(#paint180_linear_0_1)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4036 80.8185C22.1794 80.061 22.6896 79.1595 22.8773 78.2146C22.976 77.7325 22.9 77.4987 22.7418 77.4485C22.2337 77.3004 20.8566 79.0808 21.4036 80.8185Z",
    fill: "url(#paint181_linear_0_1)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5307 79.6295C18.0982 79.0006 18.4699 78.2801 18.6131 77.5318C18.6624 77.2083 18.5949 77.0623 18.5266 77.0408C18.2268 76.9966 17.4337 78.2908 17.5307 79.6295Z",
    fill: "url(#paint182_linear_0_1)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1599 81.7619L19.2301 81.7565C19.3309 81.774 19.4349 81.7808 19.5395 81.7767C19.6475 81.7772 19.756 81.7689 19.8634 81.7519C19.6962 81.6355 19.5524 81.4986 19.4367 81.3457C19.1056 80.9146 18.9175 80.416 18.8894 79.8953C18.6144 80.2204 18.297 80.5216 17.9432 80.7929C18.008 80.9073 18.0827 81.0175 18.1667 81.1226C18.3182 81.3246 18.5241 81.4946 18.7702 81.6206C18.889 81.6844 19.0205 81.7321 19.1599 81.7619Z",
    fill: "url(#paint183_linear_0_1)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8257 81.1589C15.0569 81.1917 15.2985 81.1731 15.5259 81.1052C15.256 80.8488 15.0763 80.5357 15.004 80.1961L13.7468 79.9747C13.9462 80.717 14.3402 81.0743 14.8257 81.1589Z",
    fill: "url(#paint184_linear_0_1)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7391 82.8965C23.8856 82.9005 24.0334 82.8892 24.1788 82.8628L24.0299 82.765C23.4018 82.3427 22.9551 81.7685 22.7473 81.1163C22.5063 81.3559 22.2284 81.5697 21.9214 81.7519C22.1492 82.0576 22.4351 82.3302 22.7692 82.5604C22.9299 82.673 23.1151 82.7608 23.3167 82.8197C23.4517 82.8603 23.5936 82.8861 23.7391 82.8965Z",
    fill: "url(#paint185_linear_0_1)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7068 81.1931L15.9652 81.4103C16.5486 81.5137 17.2729 81.2227 17.9356 80.7229C18.2862 80.4534 18.6008 80.1544 18.8734 79.8314C19.4168 79.213 19.7736 78.5045 19.9121 77.7684C19.9592 77.4509 19.8948 77.3077 19.8245 77.2913L18.5659 77.0697C18.6525 77.0892 18.6955 77.2341 18.6484 77.5516C18.5116 78.2859 18.1566 78.9928 17.6148 79.6098C17.0934 80.2983 16.3174 80.8407 15.4082 81.1523C15.179 81.2162 14.937 81.2302 14.7068 81.1931Z",
    fill: "url(#paint186_linear_0_1)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1021 81.8131L20.3798 82.0383C20.645 82.0606 20.9164 82.0382 21.1775 81.9723C21.4386 81.9064 21.6838 81.7986 21.8981 81.6553C22.2052 81.4731 22.483 81.2593 22.724 81.0197C23.4704 80.271 23.9635 79.3826 24.1497 78.4511C24.2394 77.9768 24.1716 77.7462 24.0194 77.7011L22.7526 77.4794C22.905 77.5289 22.9782 77.7591 22.8831 78.2338C22.7019 79.1642 22.2102 80.0518 21.4626 80.7976C21.0248 81.2724 20.4163 81.6261 19.731 81.8041C19.6244 81.8211 19.5166 81.8294 19.4093 81.8288C19.3056 81.8343 19.2024 81.829 19.1021 81.8131Z",
    fill: "url(#paint187_linear_0_1)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M106.96 81.1848L107.61 82.8314C107.862 83.4779 112.719 81.5279 113.572 83.0912L112.989 81.677C112.656 80.4304 110.426 80.8498 108.74 81.1515C107.821 81.3018 107.044 81.4329 106.96 81.1848Z",
    fill: "url(#paint188_linear_0_1)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M106.816 81.0466C106.912 81.3021 107.695 81.1676 108.676 80.9915C109.801 79.7531 111.271 78.2165 110.994 77.4361L110.958 77.3512C110.862 77.2163 110.729 77.1021 110.57 77.0167C110.41 76.9313 110.226 76.8768 110.033 76.8571C109.113 78.3821 106.601 80.5067 106.816 81.0466Z",
    fill: "url(#paint189_linear_0_1)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M104.578 74.0646L105.233 75.7433C105.669 76.8552 108.415 76.4632 109.919 76.7586C110.11 76.778 110.291 76.8318 110.449 76.916C110.607 77.0003 110.738 77.1129 110.832 77.2461L110.179 75.589C109.707 74.6699 106.784 75.1706 105.347 74.6626C105.17 74.6172 105.009 74.5401 104.876 74.4369C104.744 74.3336 104.642 74.2065 104.578 74.0646Z",
    fill: "url(#paint190_linear_0_1)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M104.379 73.9258C104.443 74.0714 104.548 74.2023 104.685 74.3093C104.822 74.4164 104.989 74.4971 105.174 74.5461C105.782 73.2655 107.646 71.6956 107.157 69.3953C107.109 69.1495 107.035 68.9084 106.938 68.6743C106.824 68.3981 106.678 68.1324 106.502 67.8805C106.951 70.748 103.781 72.4378 104.379 73.9258Z",
    fill: "url(#paint191_linear_0_1)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7584 63.3881L100.419 65.0841C100.419 65.0841 104.623 65.2242 106.341 67.7385C106.509 67.9861 106.649 68.2472 106.757 68.5187L106.097 66.8228C104.797 63.5516 99.7584 63.3881 99.7584 63.3881Z",
    fill: "url(#paint192_linear_0_1)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2219 46.7941L53.6917 47.8314C53.5285 47.6986 53.3879 47.5493 53.2732 47.387C52.3652 46.1211 53.1041 44.2123 54.2059 42.3343L52.7314 41.3196C51.4912 43.4124 50.7108 45.5643 52.2219 46.7941Z",
    fill: "url(#paint193_linear_0_1)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9935 53.6721C65.9313 53.5051 65.8248 53.3528 65.681 53.225C65.4171 53.0165 65.1008 52.8547 64.7502 52.7489C63.5269 52.3453 62.0717 52.6315 61.0007 52.4854C61.0778 52.7101 61.2212 52.9138 61.4191 53.08C62.3721 53.8613 64.3456 53.1997 65.9935 53.6721Z",
    fill: "url(#paint194_linear_0_1)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8621 48.7987C56.9886 49.0041 58.3394 48.8684 59.4388 49.0548C59.4327 48.846 59.3335 48.6505 59.1591 48.5034C59.1105 48.4646 59.058 48.4292 59.002 48.3974C58.8356 48.3073 58.6557 48.2333 58.4659 48.1768C57.3292 47.8416 55.7496 48.0662 54.4849 47.8333C54.0876 47.7719 53.7032 47.6738 53.3393 47.5409C53.4464 47.6947 53.5776 47.8361 53.7301 47.9619C54.313 48.4039 55.053 48.6943 55.8621 48.7987Z",
    fill: "url(#paint195_linear_0_1)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9699 51.9581L61.4319 52.9725C61.2208 52.7968 61.068 52.5816 60.9858 52.3441C60.9031 52.1041 60.8539 51.8561 60.839 51.6044C60.8027 50.6698 61.1672 50.0651 60.628 49.6479L60.5011 49.5641L59.1385 48.6488C59.3244 48.804 59.4301 49.0103 59.4366 49.2306C59.4502 49.5805 59.3435 50.0194 59.3705 50.5682C59.3472 51.0845 59.5601 51.5782 59.9699 51.9581Z",
    fill: "url(#paint196_linear_0_1)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4199 58.1465L67.9049 59.1698C66.8929 57.6974 67.5362 57.316 67.6139 55.9376C67.6403 55.0086 67.5577 54.5334 66.8204 54.1506L65.633 53.3462C65.7905 53.4816 65.9072 53.6432 65.9754 53.8203C66.0905 54.1749 66.1306 54.545 66.0944 54.9168C66.057 56.2923 65.4137 56.6737 66.4199 58.1465Z",
    fill: "url(#paint197_linear_0_1)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4747 49.8185L73.9259 51.4349C73.9259 51.4349 76.6002 53.1347 82.0358 54.597L82.1217 54.6163C82.5434 54.7091 82.9187 54.8953 83.2074 55.1551L81.8287 53.6238C81.5454 53.3182 81.1433 53.1008 80.6813 53.0034C75.1762 51.5335 72.4747 49.8185 72.4747 49.8185Z",
    fill: "url(#paint198_linear_0_1)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1625 71.8164L91.5601 73.3675L91.6657 73.4807C92.2203 74.04 93.2472 74.1041 94.5683 74.1889L93.1095 72.5689C92.4588 72.5487 91.8163 72.4762 91.1911 72.3524C90.7797 72.2715 90.4193 72.0837 90.1625 71.8164Z",
    fill: "url(#paint199_linear_0_1)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M90.003 71.7104C90.2786 71.9851 90.6654 72.1782 91.1068 72.2613C91.0706 71.7851 91.0976 71.3041 91.1874 70.8259C91.4359 69.2936 92.4236 67.925 91.3573 66.7301L91.2856 66.6553C90.9924 66.3674 90.6385 66.1214 90.2377 65.9266C90.4424 66.9045 89.8153 67.9838 89.6215 69.1603C89.4159 70.4757 89.5611 71.2487 90.003 71.7104Z",
    fill: "url(#paint200_linear_0_1)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7535 61.1633L81.1466 62.7025L81.2743 62.8435C82.1579 63.7064 84.4047 64.0385 86.6579 64.5424C87.8951 64.7773 89.0712 65.162 90.148 65.684C90.5203 65.8726 90.849 66.1107 91.1214 66.3893L89.6617 64.7777C89.03 64.1066 87.7195 63.4917 85.2091 62.9386C83.7398 62.6792 82.304 62.3282 80.9139 61.8888C80.4607 61.7228 80.0645 61.4751 79.7535 61.1633Z",
    fill: "url(#paint201_linear_0_1)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5527 60.9004C79.8814 61.2183 80.2981 61.4687 80.7728 61.6338C81.0925 59.9262 84.721 56.9508 83.4891 55.4717L83.4144 55.3846C83.1166 55.119 82.7295 54.9285 82.2946 54.8336L82.206 54.8139C81.9004 56.6043 78.744 59.2787 79.303 60.5439C79.3625 60.6734 79.4467 60.7937 79.5527 60.9004Z",
    fill: "url(#paint202_linear_0_1)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M107.215 55.4489L107.448 56.8991C107.184 56.7569 106.964 56.5712 106.801 56.3537C106.639 56.1362 106.537 55.8916 106.503 55.6353C106.467 55.3778 106.476 55.1153 106.529 54.8552C106.701 55.091 106.934 55.2931 107.215 55.4489Z",
    fill: "url(#paint203_linear_0_1)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M103.309 26.0195L103.311 26.0589C103.34 26.3098 103.304 26.5664 103.204 26.8119C102.25 25.6977 99.4801 25.2748 98.3178 23.7998L98.1021 22.3705C99.4682 24.0971 103.026 24.3851 103.309 26.0195Z",
    fill: "url(#paint204_linear_0_1)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M107.949 48.0582C107.955 48.2614 107.939 48.4658 107.902 48.6691C107.155 47.5467 104.944 47.5548 103.399 46.651C102.668 46.2593 102.163 45.6476 101.984 44.9377L101.979 44.7983C101.956 44.58 101.971 44.3582 102.024 44.1395C102.303 44.5813 102.705 44.9597 103.201 45.2463C105.032 46.3116 107.832 46.0879 107.949 48.0582Z",
    fill: "url(#paint205_linear_0_1)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M108.353 49.424C108.396 49.7189 108.385 50.0199 108.319 50.3177C108.1 51.4702 106.615 53.2904 106.324 54.818C106.269 55.0787 106.261 55.3417 106.297 55.5998L106.06 54.1421C105.816 52.5022 107.831 50.2199 108.088 48.864C108.09 48.8446 108.089 48.8253 108.086 48.8063C108.126 48.5989 108.143 48.3904 108.136 48.1832L108.353 49.424Z",
    fill: "url(#paint206_linear_0_1)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M107.483 36.9511L107.686 38.2991L107.692 38.457C107.694 38.5008 107.695 38.5447 107.697 38.5886C107.651 39.8193 105.743 40.3919 104.669 41.0195C103.208 41.7647 102.02 42.8584 101.758 43.9781C101.705 44.1984 101.69 44.4216 101.713 44.6414L101.496 43.2109C101.342 41.8679 102.703 40.4794 104.452 39.5846C105.366 39.044 106.886 38.5495 107.341 37.6525C107.425 37.4897 107.472 37.3176 107.479 37.1449C107.494 37.0866 107.491 37.0208 107.483 36.9511Z",
    fill: "url(#paint207_linear_0_1)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M107.242 36.7254L107.243 36.7513C107.246 36.8204 107.248 36.8852 107.251 36.9543C107.243 37.1245 107.197 37.294 107.115 37.4543C106.477 36.6758 105.102 36.166 104.205 35.8882C102.11 35.2388 97.9691 34.2956 97.7507 32.887C97.7236 32.6401 97.8028 32.3876 97.9748 32.1723C99.1346 33.2054 102.248 33.9415 104.003 34.474C105.142 34.8285 107.048 35.5531 107.242 36.7254Z",
    fill: "url(#paint208_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 127.026,
    y1: 73.3496,
    x2: 126.829,
    y2: 74.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 157.718,
    y1: 111.342,
    x2: 158.72,
    y2: 110.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 161.983,
    y1: 57.3749,
    x2: 162.422,
    y2: 56.7338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 143.03,
    y1: 78.9772,
    x2: 142.522,
    y2: 80.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 159.162,
    y1: 21.6995,
    x2: 156.117,
    y2: 21.9231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 159.769,
    y1: 39.7672,
    x2: 159.622,
    y2: 41.0572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 96.427,
    y1: 4.94296,
    x2: 97.7952,
    y2: 4.23283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_1",
    x1: 113.789,
    y1: 51.8273,
    x2: 116.704,
    y2: 52.3822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_1",
    x1: 66.7316,
    y1: 43.9927,
    x2: 69.1086,
    y2: 43.4864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_1",
    x1: 123.421,
    y1: 40.5828,
    x2: 122.71,
    y2: 41.2735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_1",
    x1: 156.745,
    y1: 49.646,
    x2: 157.718,
    y2: 53.3312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_1",
    x1: 129.799,
    y1: 88.9125,
    x2: 129.479,
    y2: 89.4382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_1",
    x1: 95.247,
    y1: 72.2544,
    x2: 94.8662,
    y2: 70.5128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_1",
    x1: 124.209,
    y1: 72.8228,
    x2: 121.569,
    y2: 73.3639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_1",
    x1: 149.947,
    y1: 13.8419,
    x2: 147.307,
    y2: 14.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_0_1",
    x1: 177.075,
    y1: 77.788,
    x2: 179.151,
    y2: 79.9002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_0_1",
    x1: 87.2474,
    y1: 98.0828,
    x2: 86.4409,
    y2: 97.1145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_0_1",
    x1: 79.957,
    y1: 49.7185,
    x2: 77.6644,
    y2: 49.3441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_0_1",
    x1: 130.213,
    y1: 82.7179,
    x2: 131.487,
    y2: 84.2339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_0_1",
    x1: 135.379,
    y1: 87.7924,
    x2: 136.479,
    y2: 86.2619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_0_1",
    x1: 78.3663,
    y1: 64.7267,
    x2: 79.0642,
    y2: 65.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_0_1",
    x1: 108.075,
    y1: 81.3446,
    x2: 106.89,
    y2: 79.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_0_1",
    x1: 118.158,
    y1: 94.7754,
    x2: 117.501,
    y2: 95.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_0_1",
    x1: 124.869,
    y1: 70.1643,
    x2: 123.907,
    y2: 69.9885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_0_1",
    x1: 102.92,
    y1: 22.0607,
    x2: 100.768,
    y2: 21.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_0_1",
    x1: 128.531,
    y1: 94.7663,
    x2: 127.401,
    y2: 95.5685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_0_1",
    x1: 140.563,
    y1: 38.406,
    x2: 142.361,
    y2: 38.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_0_1",
    x1: 128.871,
    y1: 50.5173,
    x2: 127.971,
    y2: 50.2647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_0_1",
    x1: 146.043,
    y1: 45.5847,
    x2: 147.678,
    y2: 45.5039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_0_1",
    x1: 90.412,
    y1: 33.5406,
    x2: 89.3798,
    y2: 33.5209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_0_1",
    x1: 101.288,
    y1: -5.92808,
    x2: 101.241,
    y2: -3.00703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_0_1",
    x1: 78.2806,
    y1: 74.4214,
    x2: 78.9758,
    y2: 74.6517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_0_1",
    x1: 91.5545,
    y1: 45.1818,
    x2: 92.8226,
    y2: 44.9207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_0_1",
    x1: 87.6282,
    y1: 76.9005,
    x2: 87.8817,
    y2: 77.7154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_0_1",
    x1: 90.9667,
    y1: 44.536,
    x2: 93.1993,
    y2: 44.8791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_0_1",
    x1: 86.5007,
    y1: 54.4196,
    x2: 87.7574,
    y2: 55.3222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_0_1",
    x1: 131.378,
    y1: 78.8442,
    x2: 132.921,
    y2: 76.7365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_0_1",
    x1: 83.3674,
    y1: 98.411,
    x2: 82.7006,
    y2: 97.5324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_0_1",
    x1: 87.1099,
    y1: 81.7502,
    x2: 88.0027,
    y2: 81.7152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_0_1",
    x1: 130.064,
    y1: 53.6617,
    x2: 130.424,
    y2: 55.8519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_0_1",
    x1: 119.836,
    y1: 53.1888,
    x2: 120.392,
    y2: 55.7277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_0_1",
    x1: 145.463,
    y1: 125.429,
    x2: 143.296,
    y2: 127.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_0_1",
    x1: 73.3779,
    y1: 44.1662,
    x2: 75.7107,
    y2: 44.6351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_0_1",
    x1: 74.6827,
    y1: 92.323,
    x2: 75.5746,
    y2: 90.6794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_0_1",
    x1: 127.565,
    y1: 15.1687,
    x2: 128.131,
    y2: 16.5998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_0_1",
    x1: 143.935,
    y1: 108.069,
    x2: 141.96,
    y2: 106.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_0_1",
    x1: 130.368,
    y1: 97.2654,
    x2: 133.825,
    y2: 96.2574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_0_1",
    x1: 133.64,
    y1: 84.1835,
    x2: 133.56,
    y2: 85.4138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_0_1",
    x1: 116.28,
    y1: 56.2371,
    x2: 115.58,
    y2: 55.2753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_0_1",
    x1: 183.845,
    y1: 83.6309,
    x2: 184.75,
    y2: 82.4907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_0_1",
    x1: 159.664,
    y1: 72.9354,
    x2: 160.901,
    y2: 71.7596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_0_1",
    x1: 133.626,
    y1: 65.1839,
    x2: 136.002,
    y2: 66.2909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_0_1",
    x1: 157.206,
    y1: 25.826,
    x2: 158.691,
    y2: 27.1047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_0_1",
    x1: 66.9335,
    y1: 72.416,
    x2: 68.4875,
    y2: 73.9447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_0_1",
    x1: 102.474,
    y1: 69.4117,
    x2: 101.32,
    y2: 69.2592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_0_1",
    x1: 128.516,
    y1: 106.041,
    x2: 127.263,
    y2: 107.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_0_1",
    x1: 72.5952,
    y1: 76.9204,
    x2: 72.4255,
    y2: 76.3526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_0_1",
    x1: 144.781,
    y1: 94.1027,
    x2: 145.302,
    y2: 95.7853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_0_1",
    x1: 75.0379,
    y1: 65.2502,
    x2: 73.933,
    y2: 63.8411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_0_1",
    x1: 101.338,
    y1: 50.952,
    x2: 101.203,
    y2: 51.9325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_0_1",
    x1: 94.7552,
    y1: 64.7931,
    x2: 94.5913,
    y2: 66.2057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_0_1",
    x1: 153.064,
    y1: 65.6354,
    x2: 153.341,
    y2: 66.7702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_0_1",
    x1: 138.607,
    y1: 89.6016,
    x2: 139.678,
    y2: 93.0339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_0_1",
    x1: 116.532,
    y1: 95.254,
    x2: 119.44,
    y2: 109.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_0_1",
    x1: 133.823,
    y1: 91.0868,
    x2: 136.555,
    y2: 103.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_0_1",
    x1: 125.02,
    y1: 94.8068,
    x2: 126.933,
    y2: 101.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_0_1",
    x1: 93.3038,
    y1: 92.6689,
    x2: 96.0175,
    y2: 97.1963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_0_1",
    x1: 97.5522,
    y1: 87.3131,
    x2: 103.406,
    y2: 99.4443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_0_1",
    x1: 101.798,
    y1: 86.2445,
    x2: 106.338,
    y2: 94.7211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_0_1",
    x1: 100.484,
    y1: 86.8874,
    x2: 105.099,
    y2: 95.4442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_0_1",
    x1: 105.458,
    y1: 85.7919,
    x2: 108.093,
    y2: 91.2433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_0_1",
    x1: 96.1353,
    y1: 87.9268,
    x2: 102.087,
    y2: 100.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_0_1",
    x1: 102.383,
    y1: 86.6652,
    x2: 105.274,
    y2: 91.1263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_0_1",
    x1: 98.4091,
    y1: 88.7993,
    x2: 101.418,
    y2: 93.4221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_0_1",
    x1: 166.208,
    y1: 79.2889,
    x2: 167.247,
    y2: 84.3261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_0_1",
    x1: 172.451,
    y1: 75.8666,
    x2: 173.628,
    y2: 88.7022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_0_1",
    x1: 176.844,
    y1: 76.2844,
    x2: 178.023,
    y2: 85.3847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_0_1",
    x1: 175.343,
    y1: 76.5814,
    x2: 176.504,
    y2: 85.5633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_0_1",
    x1: 180.428,
    y1: 77.2251,
    x2: 180.925,
    y2: 82.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_0_1",
    x1: 170.866,
    y1: 76.1772,
    x2: 172.017,
    y2: 88.7948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_0_1",
    x1: 177.214,
    y1: 76.8763,
    x2: 178.254,
    y2: 81.7914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_0_1",
    x1: 172.584,
    y1: 77.5134,
    x2: 173.665,
    y2: 82.6069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_0_1",
    x1: 76.0036,
    y1: 85.5117,
    x2: 81.4545,
    y2: 87.3544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_0_1",
    x1: 75.0677,
    y1: 80.609,
    x2: 86.8964,
    y2: 88.3297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_0_1",
    x1: 78.8251,
    y1: 78.6452,
    x2: 83.4671,
    y2: 80.1793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_0_1",
    x1: 78.7992,
    y1: 72.8361,
    x2: 90.756,
    y2: 79.0885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_0_1",
    x1: 83.0682,
    y1: 68.2154,
    x2: 87.6753,
    y2: 69.7223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_0_1",
    x1: 119.805,
    y1: 72.0689,
    x2: 123.329,
    y2: 86.8684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_0_1",
    x1: 136.379,
    y1: 41.987,
    x2: 139.535,
    y2: 45.9259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_0_1",
    x1: 124.786,
    y1: 51.3837,
    x2: 131.452,
    y2: 57.1687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_0_1",
    x1: 129.944,
    y1: 45.7559,
    x2: 141.099,
    y2: 51.8409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_0_1",
    x1: 130.165,
    y1: 49.7771,
    x2: 131.665,
    y2: 51.6476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_0_1",
    x1: 122.783,
    y1: 54.8868,
    x2: 126.034,
    y2: 59.8879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_0_1",
    x1: 146.427,
    y1: 53.5545,
    x2: 148.587,
    y2: 62.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_0_1",
    x1: 113.471,
    y1: 51.6113,
    x2: 117.128,
    y2: 54.5737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_0_1",
    x1: 100.318,
    y1: 74.7819,
    x2: 101.716,
    y2: 75.9112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_0_1",
    x1: 98.72,
    y1: 68.3764,
    x2: 110.053,
    y2: 78.5266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_0_1",
    x1: 105.678,
    y1: 63.7979,
    x2: 109.784,
    y2: 67.1333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_0_1",
    x1: 108.518,
    y1: 57.0883,
    x2: 121.314,
    y2: 67.0267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_0_1",
    x1: 134.54,
    y1: 102.339,
    x2: 134.531,
    y2: 104.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_0_1",
    x1: 140.491,
    y1: 96.7427,
    x2: 139.762,
    y2: 112.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_0_1",
    x1: 76.1904,
    y1: 58.6011,
    x2: 87.043,
    y2: 55.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_0_1",
    x1: 77.6903,
    y1: 48.8994,
    x2: 93.5423,
    y2: 42.6014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_0_1",
    x1: 79.7957,
    y1: 53.3753,
    x2: 82.7571,
    y2: 53.6559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_0_1",
    x1: 79.9832,
    y1: 41.2422,
    x2: 87.0046,
    y2: 41.9021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_0_1",
    x1: 78.4336,
    y1: 36.9287,
    x2: 98.3652,
    y2: 28.2386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_0_1",
    x1: 65.1313,
    y1: 72.0089,
    x2: 65.344,
    y2: 72.7622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_0_1",
    x1: 31.6646,
    y1: 58.2485,
    x2: 31.2245,
    y2: 57.6466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_0_1",
    x1: 50.6162,
    y1: 77.9535,
    x2: 51.1344,
    y2: 79.1623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_0_1",
    x1: 32.0058,
    y1: 24.5822,
    x2: 35.005,
    y2: 24.6457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_0_1",
    x1: 32.9425,
    y1: 41.5707,
    x2: 33.12,
    y2: 42.7892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_0_1",
    x1: 89.8646,
    y1: 6.67998,
    x2: 88.4966,
    y2: 6.02412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_0_1",
    x1: 76.1209,
    y1: 51.3396,
    x2: 73.3416,
    y2: 52.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_0_1",
    x1: 120.507,
    y1: 42.4196,
    x2: 118.162,
    y2: 42.0342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_0_1",
    x1: 66.8229,
    y1: 41.0808,
    x2: 67.5296,
    y2: 41.7235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_0_1",
    x1: 36.2255,
    y1: 50.8434,
    x2: 35.4382,
    y2: 54.3414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_0_1",
    x1: 63.4615,
    y1: 86.7863,
    x2: 63.7837,
    y2: 87.2805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_0_1",
    x1: 94.9102,
    y1: 69.9467,
    x2: 95.2087,
    y2: 68.2965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_0_1",
    x1: 67.3718,
    y1: 71.4476,
    x2: 70.0105,
    y2: 71.8665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_0_1",
    x1: 40.489,
    y1: 16.8996,
    x2: 43.1279,
    y2: 17.3185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_0_1",
    x1: 104.051,
    y1: 93.9913,
    x2: 104.76,
    y2: 93.0386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_0_1",
    x1: 109.161,
    y1: 48.3423,
    x2: 111.348,
    y2: 47.8515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_0_1",
    x1: 62.8945,
    y1: 81.0048,
    x2: 61.7748,
    y2: 82.4982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_0_1",
    x1: -13.1752,
    y1: 58.1911,
    x2: -14.4107,
    y2: 58.8753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_0_1",
    x1: 58.5373,
    y1: 86.0258,
    x2: 57.436,
    y2: 84.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_0_1",
    x1: 111.317,
    y1: 62.3795,
    x2: 110.718,
    y2: 63.5145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_0_1",
    x1: 83.0503,
    y1: 78.9029,
    x2: 84.0868,
    y2: 77.4222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_0_1",
    x1: 66.9118,
    y1: 68.9852,
    x2: 67.8291,
    y2: 68.7601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_0_1",
    x1: 85.3161,
    y1: 23.0324,
    x2: 87.3697,
    y2: 22.5252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_0_1",
    x1: 61.8034,
    y1: 93.7745,
    x2: 62.9241,
    y2: 94.5105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_0_1",
    x1: 50.4308,
    y1: 39.656,
    x2: 48.6776,
    y2: 39.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_0_1",
    x1: 62.4825,
    y1: 50.6769,
    x2: 63.3413,
    y2: 50.3746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_0_1",
    x1: 46.0387,
    y1: 46.6225,
    x2: 44.417,
    y2: 46.6286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_0_1",
    x1: 98.2046,
    y1: 33.4474,
    x2: 99.2073,
    y2: 33.3723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_0_1",
    x1: 85.6866,
    y1: -3.37287,
    x2: 85.8188,
    y2: -0.612698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_0_1",
    x1: 111.378,
    y1: 71.4356,
    x2: 110.72,
    y2: 71.7025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_0_1",
    x1: 97.0859,
    y1: 44.3759,
    x2: 95.8266,
    y2: 44.1764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_0_1",
    x1: 102.234,
    y1: 74.0748,
    x2: 102.023,
    y2: 74.8498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_0_1",
    x1: 98.5791,
    y1: 43.8355,
    x2: 96.437,
    y2: 44.2968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_0_1",
    x1: 102.387,
    y1: 52.8869,
    x2: 101.248,
    y2: 53.8113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_0_1",
    x1: 61.3493,
    y1: 77.3998,
    x2: 59.8058,
    y2: 75.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_0_1",
    x1: 107.951,
    y1: 94.2542,
    x2: 108.536,
    y2: 93.3985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_0_1",
    x1: 102.756,
    y1: 78.5624,
    x2: 101.889,
    y2: 78.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_0_1",
    x1: 61.2558,
    y1: 53.6529,
    x2: 60.9908,
    y2: 55.7239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_0_1",
    x1: 70.5099,
    y1: 52.8228,
    x2: 70.0773,
    y2: 55.2263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_0_1",
    x1: 114.264,
    y1: 42.8132,
    x2: 112.015,
    y2: 43.4156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_0_1",
    x1: 115.504,
    y1: 88.1843,
    x2: 114.602,
    y2: 86.6387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_0_1",
    x1: 61.8459,
    y1: 17.3919,
    x2: 61.3693,
    y2: 18.7564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_0_1",
    x1: 62.5999,
    y1: 94.6101,
    x2: 59.1709,
    y2: 93.7693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_0_1",
    x1: 59.3523,
    y1: 82.4867,
    x2: 59.4646,
    y2: 83.6501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_0_1",
    x1: 74.984,
    y1: 55.6675,
    x2: 75.5942,
    y2: 54.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_0_1",
    x1: 11.2922,
    y1: 83.5672,
    x2: 10.392,
    y2: 82.4912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_0_1",
    x1: 34.6546,
    y1: 72.801,
    x2: 33.4253,
    y2: 71.6909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE190C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F82E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C20300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#980300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_0_1",
    x1: 58.6969,
    y1: 64.6528,
    x2: 56.4979,
    y2: 65.8428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_0_1",
    x1: 34.0963,
    y1: 28.3254,
    x2: 32.7622,
    y2: 29.6016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_0_1",
    x1: 121.871,
    y1: 69.1465,
    x2: 120.486,
    y2: 70.6644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_0_1",
    x1: 88.0133,
    y1: 67.5239,
    x2: 89.1209,
    y2: 67.3104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_0_1",
    x1: 116.771,
    y1: 73.5901,
    x2: 116.91,
    y2: 73.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_0_1",
    x1: 49.5209,
    y1: 92.2074,
    x2: 49.0921,
    y2: 93.8061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_0_1",
    x1: 113.905,
    y1: 62.7548,
    x2: 114.875,
    y2: 61.3765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_0_1",
    x1: 88.3331,
    y1: 50.1253,
    x2: 88.4892,
    y2: 51.0511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FA0084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_0_1",
    x1: 94.6422,
    y1: 62.8334,
    x2: 94.8381,
    y2: 64.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00890B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3AB512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5ABC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#71C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7FC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5EBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#41B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1CAF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_0_1",
    x1: 39.8883,
    y1: 65.6532,
    x2: 39.669,
    y2: 66.7283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_0_1",
    x1: 64.4017,
    y1: 84.7622,
    x2: 62.3305,
    y2: 96.3839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_0_1",
    x1: 97.7051,
    y1: 89.0315,
    x2: 95.2553,
    y2: 93.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_0_1",
    x1: 93.5156,
    y1: 84.1812,
    x2: 88.5493,
    y2: 95.8105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_0_1",
    x1: 89.4637,
    y1: 83.3193,
    x2: 85.583,
    y2: 91.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_0_1",
    x1: 90.8224,
    y1: 83.8866,
    x2: 86.9302,
    y2: 92.1676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_0_1",
    x1: 86.0544,
    y1: 83.0234,
    x2: 83.8534,
    y2: 88.2749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_0_1",
    x1: 94.9822,
    y1: 84.717,
    x2: 89.9987,
    y2: 96.5109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_0_1",
    x1: 88.9247,
    y1: 83.732,
    x2: 86.3935,
    y2: 88.0342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_0_1",
    x1: 92.7607,
    y1: 85.6035,
    x2: 90.1302,
    y2: 90.0649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00930F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00800C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_0_1",
    x1: 85.2339,
    y1: 36.2472,
    x2: 80.3506,
    y2: 39.2536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_0_1",
    x1: 83.8201,
    y1: 30.4185,
    x2: 73.5491,
    y2: 39.2661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_0_1",
    x1: 80.6178,
    y1: 28.138,
    x2: 72.9992,
    y2: 34.0821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_0_1",
    x1: 81.5499,
    y1: 29.0446,
    x2: 73.6484,
    y2: 35.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_0_1",
    x1: 77.8057,
    y1: 26.482,
    x2: 73.0312,
    y2: 30.6302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_0_1",
    x1: 85.0038,
    y1: 31.2749,
    x2: 74.263,
    y2: 40.5298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_0_1",
    x1: 79.955,
    y1: 28.3019,
    x2: 75.3692,
    y2: 31.1623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_0_1",
    x1: 82.4503,
    y1: 31.4244,
    x2: 77.679,
    y2: 34.3844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_0_1",
    x1: 28.5885,
    y1: 78.9649,
    x2: 27.7696,
    y2: 83.7487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_0_1",
    x1: 22.5811,
    y1: 75.9774,
    x2: 21.9133,
    y2: 88.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_0_1",
    x1: 18.4729,
    y1: 76.5203,
    x2: 17.6993,
    y2: 85.1014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_0_1",
    x1: 19.8955,
    y1: 76.7442,
    x2: 19.1101,
    y2: 85.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_0_1",
    x1: 15.1326,
    y1: 77.5178,
    x2: 14.8435,
    y2: 82.7895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_0_1",
    x1: 24.0714,
    y1: 76.2039,
    x2: 23.3971,
    y2: 88.1083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_0_1",
    x1: 18.1489,
    y1: 77.0833,
    x2: 17.3445,
    y2: 81.7355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_0_1",
    x1: 22.531,
    y1: 77.5263,
    x2: 21.6977,
    y2: 82.3466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_0_1",
    x1: 113.682,
    y1: 81.762,
    x2: 108.632,
    y2: 83.7791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_0_1",
    x1: 114.45,
    y1: 77.1271,
    x2: 103.67,
    y2: 85.1276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_0_1",
    x1: 110.734,
    y1: 75.406,
    x2: 106.411,
    y2: 77.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_0_1",
    x1: 110.724,
    y1: 69.9507,
    x2: 99.5577,
    y2: 76.9072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_0_1",
    x1: 106.288,
    y1: 65.7484,
    x2: 101.975,
    y2: 67.4487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0062C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0086E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_0_1",
    x1: 55.0416,
    y1: 42.9158,
    x2: 52.3116,
    y2: 46.8661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_0_1",
    x1: 66.2557,
    y1: 51.3381,
    x2: 60.2423,
    y2: 57.0498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_0_1",
    x1: 61.1755,
    y1: 46.232,
    x2: 50.975,
    y2: 52.4791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_0_1",
    x1: 61.1552,
    y1: 50.0207,
    x2: 59.8563,
    y2: 51.8927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_0_1",
    x1: 68.3943,
    y1: 54.5736,
    x2: 65.6598,
    y2: 59.5367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_0_1",
    x1: 76.8547,
    y1: 51.1645,
    x2: 73.5594,
    y2: 54.1334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_0_1",
    x1: 90.2539,
    y1: 72.4872,
    x2: 88.9945,
    y2: 73.6209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_0_1",
    x1: 91.5583,
    y1: 66.4283,
    x2: 81.4438,
    y2: 77.0693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_0_1",
    x1: 84.7399,
    y1: 62.3496,
    x2: 81.0397,
    y2: 65.6869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_0_1",
    x1: 81.79,
    y1: 56.1504,
    x2: 70.2289,
    y2: 66.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FA6E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FA2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CD0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_0_1",
    x1: 112.594,
    y1: 56.4858,
    x2: 101.569,
    y2: 53.6923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_0_1",
    x1: 105.098,
    y1: 24.4973,
    x2: 88.6353,
    y2: 23.7595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_0_1",
    x1: 110.531,
    y1: 47.4237,
    x2: 94.9014,
    y2: 41.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_0_1",
    x1: 108.719,
    y1: 51.6859,
    x2: 105.744,
    y2: 52.1635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_0_1",
    x1: 107.988,
    y1: 40.2961,
    x2: 101.22,
    y2: 41.3301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_0_1",
    x1: 109.28,
    y1: 36.2086,
    x2: 89.6773,
    y2: 28.6944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFirework);
export default __webpack_public_path__ + "static/media/image-firework.1054dc7bbf6ac22d5d0fa5c5bdab35b9.svg";
export { ForwardRef as ReactComponent };